var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 288.59 255.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-2 {\n        opacity: .7;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {\n        stroke-width: 0px;\n      }\n\n      .cls-3, .cls-8 {\n        fill: #d0d2d3;\n      }\n\n      .cls-4 {\n        fill: #37b34a;\n      }\n\n      .cls-15 {\n        letter-spacing: 0em;\n      }\n\n      .cls-16 {\n        stroke: #3e3d51;\n        stroke-miterlimit: 10;\n        stroke-width: 3.46px;\n      }\n\n      .cls-16, .cls-17 {\n        fill: none;\n      }\n\n      .cls-5, .cls-8, .cls-12, .cls-13 {\n        fill-rule: evenodd;\n      }\n\n      .cls-6 {\n        fill: #ec1e25;\n      }\n\n      .cls-18 {\n        isolation: isolate;\n      }\n\n      .cls-19 {\n        font-size: 11.17px;\n      }\n\n      .cls-19, .cls-20 {\n        font-family: Gibson-Regular, Gibson;\n      }\n\n      .cls-21 {\n        letter-spacing: 0em;\n      }\n\n      .cls-22 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-23 {\n        letter-spacing: .02em;\n      }\n\n      .cls-24 {\n        font-family: Gibson-SemiBold, Gibson;\n        font-size: 7.3px;\n        font-weight: 600;\n      }\n\n      .cls-24, .cls-20 {\n        fill: #231f20;\n      }\n\n      .cls-7 {\n        fill: #808184;\n        mix-blend-mode: multiply;\n      }\n\n      .cls-9 {\n        fill: #fff;\n      }\n\n      .cls-10, .cls-12 {\n        fill: #333343;\n      }\n\n      .cls-11 {\n        fill: #8181a7;\n      }\n\n      .cls-25 {\n        letter-spacing: 0em;\n      }\n\n      .cls-26 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-13 {\n        fill: #230000;\n      }\n\n      .cls-27 {\n        letter-spacing: 0em;\n      }\n\n      .cls-28 {\n        letter-spacing: 0em;\n      }\n\n      .cls-14 {\n        fill: #3e3d51;\n      }\n\n      .cls-20 {\n        font-size: 2.67px;\n      }\n\n      .cls-29 {\n        letter-spacing: -.07em;\n      }\n\n      .cls-30 {\n        letter-spacing: 0em;\n      }\n\n      .cls-17 {\n        stroke: #231f20;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: .78px;\n      }\n\n      .cls-31 {\n        letter-spacing: .02em;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.05,
    dy: 6.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 4.32
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 20.79,
    y: 46.83,
    width: 137.21,
    height: 178.53,
    transform: "translate(-32.22 27.83) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.99,73.75c-.02-.09-.06-.17-.14-.13-.22.14-.48.59-.43.81.14.51.51,1.12.83,1.18.13.02.5-.14.62-.26.01-.03-.08-.13-.09-.18-.1.03-.3.19-.42.16-.33,0-.49-.59-.53-.91l.15-.61c-.08.14-.25.3-.32.29-.05-.12.2-.45.32-.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.86,74.67c.07.22-.55.46-.67.16.24.05.53,0,.67-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.93,74.61c.46-.32,1.16.57.85,1.14.04-.45-.3-1.15-.85-1.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.66,74.84s0-.07.01-.06c.03.03.1.02.11,0,.27-.04.67.28.86.76.14.42-.68,1.65-.9,2.21-.05.42.39.79.29.77-.86-.24-.5-1.1-.45-1.18.56-1.16,1.22-1.79.39-2.29,0,0-.21-.02-.27-.04-.05-.03-.07-.11-.06-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.34,79.16s.13-.27.14-.3c0,0,0-.04.04-.13.09-.31-.13-.75-.53-.87-.45-.14-1,.31-1.59.3-.31-.07-.46-.52-.46-.45-.03.7.65.6.72.58.93-.13,1.44-.62,1.66.26,0,0,0,.09-.01.15-.07.15-.17.38-.17.38-.05.02.18.05.2.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.86,72.74c-.23-.12-.57-.12-.81-.11,0,0-.03.05-.04.09.15-.02.63.02.84.09.03.01.01-.06.01-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.29,73.9c-.06-.26-.12-.41-.13-.58,0,0-.05.07-.09.09.05.08.12.38.12.52,0,.02.1-.03.1-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.7,76.8c-.31-.8-.29-.84-.36-1.19,0,0,.08-.01.18-.05-.1.18.29,1.11.47,1.29,0,0-.14.03-.29-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.66,76.38c-.34-.76-.29-.76-.35-1.09,0,0,.07-.02.17-.06-.11.17.14.79.3.97,0,0,.04.25-.12.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.29,75.62c-.24-.53-.24-.5-.3-.73,0,0,.03-.03.1-.06-.07.12.16.37.32.72.06.1.04.13-.12.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.61,74.6c-.17-.2-.16-.2-.24-.26,0,0-.02.01-.05.05.07-.03.12.13.22.27.04.04.05.04.07-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.13,75.21c0-.27.02-.48.04-.65,0,0-.07.02-.11.02.03.1-.04.5-.03.65l.1-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.65,75.32c.03-.26.07-.49.11-.65,0,0-.08.02-.12.01.03.09-.08.48-.09.64,0,0,.1,0,.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.91,74.96c-.06-.37-.11-.6-.15-.84,0,0-.04.1-.09.12.03.12.07.6.12.79,0,0,.11-.07.12-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.94,73.3c-.2-.3-.34-.47-.45-.66,0,0,0,.11-.04.13.09.09.32.43.4.61.01.02.08-.07.09-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.72,74.48c-.12-.43-.22-.68-.29-.96,0,0-.03.12-.07.13.08.14.22.66.25.89,0,.02.1-.06.11-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.14,71.71c.45.08.72.11,1,.18,0,0-.09-.08-.08-.12-.16,0-.68-.09-.9-.18-.02,0,0,.11,0,.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.59,70.59c.31-.18,2.93,1.47,3.42,1.96,0,0,.13-.08.14-.11-.22-.34-3-2.16-3.47-2.01,0,0-.09.15-.09.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.54,72.63c.15-.09,1.2.42,1.44.65,0,0,.17-.01.09-.07-.11-.16-1.27-.8-1.49-.73l-.04.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.43,73.55c.12,0,.6.23.86.34,0,0,.17-.01.08-.07-.13-.1-.76-.49-.94-.47,0,0,.01.2,0,.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.14,74.37c.11,0,.18.07.44.19,0,0,.17-.01.09-.08-.14-.1-.34-.29-.52-.29v.18h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.69,75.15c.11,0,.16.09.34.21,0,0,.02-.07.04-.14-.14-.1-.18-.14-.32-.21l-.06.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.94,75.82c.11,0,.56.47.76.6,0,0,.01-.06.02-.14-.13-.1-.68-.61-.82-.68l.04.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.45,76.54c.11,0,.64.54.84.67,0,0,.01-.06.03-.14-.14-.1-.65-.6-.78-.66l-.1.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.03,77.18c.11,0,.57.5.7.74,0,0,.03-.04.05-.12-.09-.14-.55-.75-.68-.79-.12-.04-.15.13-.07.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.34,77.91c.09-.02.64.38.8.6,0,0,.05,0,.06-.08-.07-.14-.63-.6-.75-.64-.13-.05-.24.03-.11.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.73,79.11c.06,0,.35.24.45.38,0,0,.06,0,.08-.06-.04-.09-.3-.36-.38-.38-.08-.03-.22.02-.15.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.24,79.35s.28.17.38.31c0,0,.07-.02.08-.06-.05-.1-.35-.33-.42-.36-.08-.02-.05.05-.04.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.75,78.42c.13.07.65.33.99.59,0,0,0,.04.01-.03-.26-.27-.8-.57-.9-.62-.34-.18-.29-.17-.1.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.3,76.09c.11,0,.56.53.79.94,0,0,0-.05.02-.13-.1-.21-.67-.92-.8-.98,0,0,0,.16,0,.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.73,77.12c.11,0,.68.52.87.64,0,0,.05-.03.07-.11-.14-.1-.73-.55-.85-.6l-.08.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.65,72.63c.28.09.47.16.47.17-.01.02.02-.1.01-.15-.08,0-.37-.05-.51-.13-.02,0,.03.1.03.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.57,73.59c.28.08.28.09.28.09-.01.02.04-.08.04-.13-.08,0-.13-.05-.28-.09,0,0-.04.12-.04.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.27,74.4c.28.08.24.11.24.11,0,.02.05-.08.05-.13-.08-.04-.11-.05-.25-.1,0,0-.04.11-.04.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.29,72.84c-.29-.25-.55-.43-.73-.6,0,0,.02.07-.02.1.13.06.55.45.68.6.01.02.07-.1.07-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.36,73.59s.03-.13.05-.12c.14.14.21.32.13.56-.03-.19-.07-.3-.18-.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.82,73.94c.19.14-.61.99-.77.79-.07-.09-.03-.65.03-.92.04-.18-.05-.28-.1-.28-.1,0,.09-.24.1-.24.18-.19.3.05.25.14-.18.32-.06.38-.03.37.06-.06.06.28-.09.48-.03.03-.04.17.03.22.21-.1.53-.35.59-.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.63,74.22c-.11.06-.2.01-.23.03.04.15-.03.19-.29.22-.08.06-.16.22-.18.29-.12.48.36.91,1.04.59-.72-.29-.5-.82.2-.93,0-.03.24-.23.23-.29-.04.01-.35.03-.47.07-.06.02.12.11.06.13-.41.12-.95.55-.46.93.01.02-.47.11-.45-.42,0-.09.04-.23.11-.24.1-.03.27-.08.29-.12l.14-.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.25,74.13c1.22-.16,1.1-.24,1.26-.3.11-.03.36-.09.59.12.11.09-.35.55-.64.67.2-.3.45-.52.34-.58-.11-.01-.3,0-.39.1-.08.09-.3.05-.48.08-.09,0-.19.01-.3.04-.09.02-.23.02-.35.04-.07.02,0,0-.01-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.51,72.61c.03.11.1.56,0,.68-.08.21-.36.24-.25.66.2.08.35,0,.49-.09l-.04-.1c-.3.09-.38.1-.3-.08-.02-.05.18-.17.25-.47.03.14-.04.56-.05.58q.08-.01.1-.02s.02-.32.03-.48c0-.04.05-.08.05-.09.02-.15-.06-.39-.28-.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.82,73.42s-.03-.19.04-.15c.22.13.34.4-.05.66.16-.27.16-.45,0-.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m20.08,72.64s.07-.09.05-.14c-.08-.21-.45-.35-.42-.29.09.21.16.45.17.75-.02-.04.08-.07.1-.14.03-.16-.02-.23-.06-.36,0-.03.11.03.16.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m20.82,72.36s.1.16.13.11c.27-.6-.11-.85-.33-.81-.19.03.05.3-.12.58,0-.04.05.13.1.07.11-.13.09-.22.13-.36.01-.02.15.12.09.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.84,73.17s.12.11.16.07c.44-.46.62-.9.08-1.39.21.55.26.81-.24,1.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m20.17,73.51s-.05.16.05.12c.3-.1.83-.97.57-1.06-.03-.01-.06-.07-.07-.06-.2.05-.42.56-.64.8.02-.04.02.11.07.07.21-.13.45-.67.55-.65.1.02-.31.61-.54.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.2,72.12s-.14-.1-.05-.13c.21-.06.77.09,1-.02.06-.03.22,0,.24.07.01.02-.05.35-.08.36-.21.08-.81-.05-1.13-.05.04,0-.08-.08,0-.1.23-.04.92.09.99.02,0,0,.06-.03.03-.04-.16-.08-.78-.15-.99-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23,71.55s-.1-.03-.1-.07c-.02-.11.34-.1.37-.13.02-.01.04,0,.09.02,0,0,.31.29.3.36-.03.12-.23.1-.33.16.03,0-.14-.09-.11-.09.14-.05.29-.06.27-.11,0-.02-.15-.21-.19-.21-.14,0-.21.06-.3.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.99,70.1s-.1-.04-.14-.02c-.1.06.16.31.16.36,0,.02.06.03.11.05,0,0,.37.06.42,0,.08-.09-.03-.25-.05-.36.01.02-.2-.03-.19-.01.06.14.11.23.06.26-.03,0-.18.03-.2,0-.09-.1-.14-.18-.17-.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.01,70.17s-.2,0-.23.02c-.07.07.47.26.47.3,0,0,.04.03.09.03,0,0,.43-.01.46-.07.05-.12-.13-.23-.18-.34.01,0-.2,0-.18.02.09.11.14.18.09.21-.02.01-.17.06-.19.05-.11-.07-.27-.13-.32-.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.48,72.11s-.05-.11-.03-.11c.15-.03.27-.07.3-.1.02-.01.06.01.1.06.04.08.32.44.26.56-.07.14-.31.1-.41.15.03,0-.1-.08-.03-.14.12-.06.28-.07.28-.12.01-.07-.14-.31-.2-.31-.12-.02-.19-.01-.28.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.81,72.91s-.01-.13,0-.13c.12-.06.27-.08.32-.09.11,0,.18.09.2.14.07.19.07.18.03.31-.04.15-.08.34-.18.4.02,0-.09-.16-.06-.25.05-.14.08-.22.07-.25,0-.16-.1-.19-.15-.18-.12.01-.17.02-.25.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.08,71.42c.06.01-.23-.03-.24-.06,0-.07.51-.09.42-.18-.03-.02.08-.04.22,0,.03,0,.38.07.39.13.02.08-.08.12-.24.18.04,0-.15.03-.18-.01-.04-.08.32-.07.26-.11,0,0-.2-.09-.3-.05-.09.02-.32.06-.33.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.1,72.55s-.03-.08.03-.11c.1-.06,1.14.08,1.11.26,0,0-.04.18-.11.34-.13.24-.78-.14-1.07-.15.05.02-.06-.08,0-.09.24-.04.85.11.95.12.08,0,.09-.18.06-.2-.18-.11-.71-.24-.96-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.16,73.07s-.04-.05,0-.08c.09-.04.82.1.78.28,0,0-.05.25-.16.35-.08.07-.31-.21-.48-.28.04,0-.08-.22,0-.13.11.12.29.2.37.21.06.01.11-.13.09-.14-.18-.09-.37-.17-.61-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.24,73.52s0-.07.04-.07c.08,0,.4.25.32.36,0,0-.09.18-.21.22-.07.03-.18-.22-.29-.31.03.02.05-.21.08-.12.06.12.09.09.19.21.03.03.04-.02.02-.07-.03-.15-.01-.12-.16-.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.51,71.16s-.05-.03-.03-.06c.03-.06.35-.2.4-.09,0,0,.09.15.07.25-.01.06-.23.05-.34.08.03,0-.14-.13-.06-.12.11,0,.11-.02.23-.04.05-.01.01-.03-.03-.05-.12-.04-.08-.04-.24.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.69,73.92s.04-.17.08-.14c.08.06.21.41-.03.76-.03.06-.28.16-.36.03-.05-.09-.03-.27.11-.52,0,.04.12-.2.1-.1-.04.14-.05.27-.05.44,0,.04.08.09.13-.08.06-.19.06-.16.02-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.21,73.2s.05-.22.09-.17c.1.18.36.77.24,1.11-.04.1-.38.28-.53.13-.08-.08-.07-.39-.1-.67.01.05.13-.15.12-.05-.02.17,0,.39.1.53.01.02.21.03.24-.13.04-.19-.06-.5-.16-.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.2,75.72s-.13-.04-.13.08c-.01.49.25,1.07.63,1.42.12.1.57.14.68-.11.08-.19-.17-.59-.38-.99,0,0-.07-.38-.12-.47-.07-.09-.16.05-.17.06-.02.04.07.39.07.43.07.37.36.4.38.88,0,0-.32.09-.46-.03-.32-.28-.43-.85-.5-1.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.51,75.76c.05-.05-.06-.29-.15.1-.14.6.48.9.64,1.41.05.14.35.3.43.02.07-.26-.29-.53-.47-.97,0,.02-.02-.47-.08-.56-.04-.09-.15-.02-.16,0-.01.02.04.49.04.52.08.37.4.46.45.93,0,0-.1.1-.14-.07-.07-.32-.79-.56-.57-1.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.17,75.35s-.13-.04-.13.08c-.02.47.23,1.03.62,1.35.11.1.5-.04.49-.24.02-.28-.08-.41-.29-.8,0,.02-.09-.49-.15-.55-.06-.08-.14,0-.15.03-.01.02.09.33.1.46.03.31.24.59.31.81,0,0-.19.19-.33.08-.31-.26-.42-.81-.49-1.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.95,74.97s-.13-.03-.14.07c-.03.41.2.88.56,1.15.1.07.36-.17.38-.33.04-.23.03-.29-.15-.59,0,0-.34-.51-.4-.57-.05-.05-.09.05-.09.07-.01.02.22.35.26.43.12.23.21.31.21.53,0,.04-.13.26-.21.16-.22-.28-.38-.59-.42-.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.92,75.48s-.06-.22,0-.18c.42.3.92.64,1.18,1.04.07.09.1.49-.09.55-.27.07-.98-.54-1.16-.79-.04-.05.06-.16.08-.17.02-.01.84.76.99.75,0,0,.11-.22,0-.37-.2-.27-.7-.66-.99-.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.63,76.29s.07-.19.1-.16c.42.41.83.67,1.04,1.09.08.15-.02.36-.17.42-.27.1-1.16-.64-1.38-.85-.04-.03-.02-.03.11-.14,0-.01.93.8,1.06.79,0,0,.3-.06.17-.29-.17-.29-.64-.67-.92-.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.96,76.98s0-.16.06-.11c.46.3.85.5,1.06.9.07.14.05.28-.09.35-.27.1-1.27-.56-1.48-.77-.02-.03-.02-.04.12-.15,0,0,1.03.78,1.16.76,0,0,.24-.04.07-.26-.21-.25-.61-.54-.91-.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.01,78s.07.05.14.09c.01.02.05-.05,0,.11-.02.04-.05.05-.1.07-.12.03-.37-.34-.4-.57,0,0,.13.1.17.13.01,0,.06.23.16.27,0,0,.01,0,.03-.05.02-.11-.02-.04.02-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.18,77.52s.08-.12.13-.08c.44.3.62.45.93.65.33.21.2.28.04.27-.64-.01-1.55-.8-1.85-.93,0,0,.1-.02.23-.04,0,0,1.28.79,1.41.77,0,0,.21.12,0-.04-.26-.18-.6-.43-.91-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.28,76.33s-.07.1,0,.18c.31.27.77.91.91,1.23.15.35.26.24.27.09.08-.79-.68-1.95-1-2.14,0,0-.02.03-.08.11,0,0,.86.73.96,1.71,0,0,0,.13-.1,0-.25-.35-.71-.96-.96-1.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.99,77.34s-.12.09-.05.16c.31.33.57.69.9.9.31.2.34-.02.33-.15-.08-.77-.58-1.25-.89-1.53,0,0-.03.07-.07.15,0,0,.69.5.79,1.28,0,0-.03.14-.14.07-.38-.23-.56-.46-.86-.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.31,78s-.15.08-.08.13c.36.25.82.66,1.18.79.33.13.35-.11.29-.21-.43-.75-.52-.76-.89-1.09,0,0-.08.04-.1.14,0,0,.46.16.81.89,0,0,0,.13-.13.09-.41-.16-.7-.4-1.07-.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.6,79.17s-.35-.09-.22,0c.36.24.6.51.94.66.38.16.35-.09.31-.22-.12-.32-.32-.55-.68-.87,0,0-.02.1-.04.19,0,0,.24.28.53.61.02.03-.02.12-.11.09-.32-.08-.38-.18-.73-.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.15,78.61s-.13,0-.09.04c.14.17.48.51.72.67.22.15.2,0,.15-.1-.22-.48-.34-.54-.57-.83,0,0-.04.03-.07.1,0,0,.15.08.47.58,0,0,.03.12-.04.07-.28-.19-.31-.26-.56-.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.64,78.46s-.25.04-.18.07c.43.19,1.04.67,1.43.81.26.09.25-.13.2-.22-.12-.22-.36-.43-.93-.86,0,0-.11,0-.13.09,0,0,.3.03.86.69,0,0,0,.15-.06.12-.33-.18-.75-.41-1.18-.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.33,74.49s-.05,0-.04.03c.05.17.17.44.39.56.06.03.15-.05.17-.12.04-.1.08-.22-.02-.34.03-.03-.31-.51-.38-.49-.04.01-.05.05.02.16,0,0,.19.28.21.31.07.1.07.13.05.23,0,.02-.03.08-.08.05-.15-.08-.32-.23-.33-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.99,74.92s-.02.19,0,.2c.37.3,1.09.96,1.11.85.03-.1-.01-.3-.13-.42.02-.03-.89-.94-.95-.92-.03,0-.04.11.04.19.13.14.79.59.77.76,0,0-.04.06-.07.04-.15-.13-.74-.56-.78-.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.22,74.53s.08-.06.11-.02c.08.17.16.63,0,.94-.05.09-.33.21-.49.07-.12-.1-.02-.81.09-1.12.01.05.12.05.06.2-.05.13-.13.63-.03.78,0,0,.22.05.26-.09.05-.18.07-.5,0-.76h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.86,74.02s.15-.1.16-.03c.05.23.31.8.16,1.2-.04.12-.49.4-.66.23-.09-.09-.05-.66-.08-1,.02.05.09-.16.1-.05.02.26.02.69.13.86,0,.02.32-.02.36-.2.04-.22-.05-.7-.17-1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.5,72.56s-.07-.24.02-.15c.34.31.76.75.73,1.06,0,.11-.29.52-.48.36-.09-.09-.27-.55-.39-.91.04.06-.01-.17.04-.06.12.2.27.55.41.72.01,0,.22-.1.22-.28-.02-.23-.32-.52-.55-.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.69,70.79s-.29-.1-.18-.1c.45-.03,1.55.02,1.72.2.06.07.23.5-.01.52-.13.01-1.06-.15-1.38-.29.06.01-.13-.16-.04-.13.2.04,1.08.24,1.28.24,0,0-.02-.21-.13-.3-.14-.13-.95-.14-1.26-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.6,71.4s-.24-.23-.03-.23c.49,0,2.67,1.32,2.78,1.55.16.27-.1.59-.4.39-.74-.46-1.84-1.14-2.3-1.23.06.03-.08-.17-.04-.29.05-.13,2.21,1.23,2.36,1.3,0,0,.21,0,.13-.13-.08-.16-2.2-1.29-2.5-1.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.64,72.25s-.13-.16.03-.16c.39,0,1.88.97,1.92,1.11.07.28-.28.5-.46.43-.59-.26-1.15-.62-1.5-.69-.02-.14.02.18-.04-.24-.02-.11,1.41.7,1.5.75,0,0,.38-.02.31-.25-.03-.1-1.52-.89-1.76-.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.53,73.2s-.01-.17.02-.17c.38-.01,1.26.63,1.3.77.08.27-.28.5-.46.43-.58-.25-.67-.29-1.02-.35.03-.11.05-.09.04-.23-.01-.09.85.34.95.39,0,0,.32-.05.26-.26-.04-.1-.87-.54-1.08-.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.26,74.09s0-.15.06-.15c.39.05.75.42.8.55.08.27-.35.47-.51.41-.56-.25-.24-.15-.6-.21.02-.11.05-.07.06-.17,0-.09.49.14.58.19,0,0,.26-.02.24-.23,0-.1-.42-.35-.64-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.94,70.32s.11-.26.16-.25c2.41.72,3.26,2.47,4.08,2.7.35.09-.83.25-1.16.12-.87-.36-2.33-1.73-3.51-1.94.07.05-.16-.21-.14-.22,1.65.14,3.23,1.87,3.71,2,0,0,.54.08.42-.08-.56-.73-2.72-2.35-3.55-2.33h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.09,71.48s-.14-.11-.07-.12c.53-.03,1.21.18,1.38.3.07.05.22.5,0,.53-.1.02-.63.05-.95-.1.06.01-.03-.03-.08-.19-.02-.05.74.19.89.1,0,0,.08-.21-.03-.3-.14-.1-.82-.21-1.12-.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.55,72.38s-.06-.14-.02-.14c.36,0,.7.17.81.3.04.05.13.56-.02.52-.33-.09-.37.04-.66-.12-.03-.08,0-.07-.04-.2,0-.05.52.23.61.15,0,0,.04-.19-.05-.28-.09-.11-.43-.19-.63-.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.47,73.73s-.05.12-.02.14c.29.18.47.2.63.14.05-.01.24-.52.14-.6-.04-.04-.22-.21-.58-.19.02.03,0,.24,0,.16,0-.02.32-.02.41.15,0,0,0,.26-.09.3-.12.05-.28-.03-.47-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.19,74.48s-.03.09-.01.11c.27.17.37.3.51.23.03-.02.3-.48.21-.57-.02-.03-.12-.16-.49-.26.02.03-.04.23-.04.16,0,0,.3,0,.4.15,0,0-.09.29-.17.33-.11.05-.23-.08-.42-.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.52,73.4s.05-.13.11-.04c.28.35.34.91.3,1.23-.02.14-.27.56-.48.28-.08-.09-.24-.67-.29-1.04.02.05.08-.15.11-.05.08.2.26,1,.34.95.05-.03.18-.11.19-.34.01-.23-.14-.68-.28-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.57,77.24c.07,0,.03.16.09.19.57.21,2.69,1.05,3.12,1.04.18,0,.97-.5.58-.65-.13-.06-3.44-1.04-3.95-1.13.09.04.02.13.11.15.23.08,3.76,1.07,3.69,1.13-.05.04-.25.31-.52.29-.3-.02-2.73-.85-3.13-1.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.62,77.8c.06,0-.07.11,0,.14.45.21,2.05.99,2.41.99.12,0,.79-.16.52-.32-.1-.06-.34-.02-.14-.03.05,0-.27.21-.48.17-.25-.02-1.98-.77-2.3-.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.49,78.19s-.19.06-.02.14c.35.15,1.68.9,1.93.91.08,0,.61-.13.51-.18-.06-.03-.17-.04-.2-.05,0,0-.18.09-.33.08-.17-.03-1.66-.76-1.9-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.66,77.58s-.1.09.05.15c.32.15,2.29.86,2.27.85-.03-.04.22-.06.17-.06-.15-.02-2.25-.78-2.49-.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.56,78.01s-.09.04,0,.11c.23.18,1.79.89,1.82.83.02-.03.18-.04.14-.05-.12-.02-1.77-.76-1.96-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.71,78.59s.05.14.1.18c.53.42,1.09.59,1.14.6.26,0,.22-.09.2-.1-.37-.1-.19.03-1.43-.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.48,76.96s-.1.08.13.2c.27.15,3.04.99,3.03.98-.02-.05.2-.12.16-.12-.12,0-3.08-.9-3.33-1.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.58,72.18s-.2-.2-.02-.13c.4.16,1.05.5,1.13.82.03.15-.28.55-.33.44-.07-.13-.05-.1-.05-.16,0,0,.2-.14.15-.32-.06-.2-.59-.52-.87-.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.58,74.75s-.03-.11-.09,0c-.15.27-.28.63-.15.8.11.14.47.11.43.02-.03-.08-.03-.06-.05-.09,0,0-.21.02-.26-.06-.08-.11.04-.47.13-.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.18,79.43s-.12.09-.02.16c.17.12.4.29.57.37.09.04.21-.14.19-.17-.03-.06-.05-.08-.09-.08,0,0-.12.1-.18.07-.07-.06-.32-.21-.47-.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.72,73.19s-.04-.27.06-.12c.22.37.62,1.05.41,1.34-.07.1-.14.17-.13.09.02-.12-.02-.18-.01-.19,0,0-.03.04.02-.09.07-.18-.21-.75-.35-1.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.56,72.39s.04.09.01.13c-.02.04-.11.02-.18-.09-.7-1.25-1.98-.51-2.06-.82s-.15-.49-.11-.7c0-.08.25-.17.43-.24.24-.09.06.19.02.18-.08-.02-.27.04-.28.15,0,.17-.02.36.1.47.12.11,1.31-.43,2.06.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.28,71.76c.11-.05.47.76.54,1.05.01.09-.22.96-.44,1.15,0,0-.1-.3-.08-.31.19-.15.3-.65.27-.79-.17-.59-.26-.64-.52-.98-.79-1.1-1.86-.66-2.02-.86-.23-.28-.14-.49-.11-.7.02-.08,2.13-1.05,4.42-.44.12.03.45.05.71-.04.07-.02-.29.5-.57.65-.09.04-.38.26-.69.15,0,0-.13-.2-.14-.26,0-.07.29-.05.22-.06-.04,0,.03.16.08.15.16-.03.53-.24.53-.24-1.73-.72-4.34.1-4.34.18-.02.21-.04.37.1.44.13.08,1.33-.3,2.05.94h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m20.72,73.62s.05.1.13.06c.24-.17.52-.42.24-.57-.02,0-.27.03-.29.08-.08.15-.43.41-.67.66.02-.03-.17.16.03.08.28-.11.81-.84.86-.65.02.1-.09.13-.29.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.09,71.61l.16-.04.09.1c-.06.02-.1.04-.17.05l-.08-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.09,70.64l.26-.08.19.06c-.1.03-.15.05-.27.07l-.19-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.55,72.19l.16-.03.1.19s-.11.04-.17.04l-.09-.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.91,73.03l.14-.07.06.11s0,.09-.08.09l-.12-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.64,73.86c.2.04.37.13.53.22.02.1-.05.25-.13.37-.05-.05-.1-.12-.16-.17.02-.06.06-.07.09-.11-.1-.11-.23-.15-.39-.2.02-.04.04-.07.06-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.93,74.8c.22.01.44.18.59.29.03.1-.06.2-.15.32-.16.53-.16.14-.19.02.01-.06.07-.27.1-.31-.1-.1-.26-.14-.41-.2.02-.05.04-.09.06-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.9,73.24c.17.05.33.09.5.1.03,0,.06-.02.07-.03-.05.25-.14.43-.26.64-.17-.07-.32-.12-.48-.21.02-.05.02-.09.05-.13.09.09.25.13.37.16.03-.08.05-.17.08-.24-.15-.03-.26-.11-.36-.17.03-.05.01-.06.04-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.82,72.42c.18-.03.32.07.48,0,.01-.02.03-.06.03-.09.11.3.21.68.16.77-.18.07-.32.07-.51.03,0-.07,0-.17,0-.23.13.04.21.05.33.01-.02-.1-.06-.21-.06-.31-.15.04-.24-.02-.36-.02,0-.07-.04-.09-.05-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.38,71.57c.17-.02.3.02.44-.08.01-.02,0-.04.02-.08.16.27.38.61.43.81-.17.11-.37.05-.59.06-.02-.07-.01-.17-.04-.22.13,0,.22,0,.33-.06-.04-.09-.11-.26-.14-.35-.13.08-.24.03-.35.05-.02-.07-.08-.07-.1-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.38,70.54c.12-.12.68-.21.84-.27-.01-.04.11-.02.13-.1.3.1.7.37.87.49-.05.21-.32.12-.5.21-.1-.08-.1-.07-.15-.1.11-.08.24-.03.33-.11-.11-.03-.38-.17-.44-.26-.11,0-.78.16-.89.22-.06-.04-.12-.04-.19-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.87,70.96c.15-.07.24-.05.41-.13,0-.02.01-.06.02-.09.24.16.39.4.43.56-.15.1-.25.08-.45.11-.03-.04-.07-.1-.1-.15.14-.02.21-.04.31-.1-.05-.06-.11-.13-.15-.19-.12.04-.2.06-.31.1-.03-.04-.14-.06-.16-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m20.17,75.47s.03-.08-.06-.19c-.01,0-.02.15-.08.21-.23.54-.88.87-.99,1.65-.08.57.06,1.14.45,1.6.45.54,1.6-.04,2.22-.21.18-.04.15.29.18.39.05-.04.1-.25.1-.26.04-.35-.2-.39-.27-.36-1.03.42-1.66.54-2.03.19-.54-.52-.52-.96-.39-1.33.33-.87.52-.74.87-1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m31.02,73.09c.08.2.3.48.47.72.08.1.19.28.2.35.18,1.31.91,3.41.67,3.67-.02-.07-.07-.13-.08-.2-.24-1.04-.93-1.89-1.28-2.86-.03-.07-.08-.2-.14-.25-.28-.29-.68-.16-1.28-1.36.05-.01.08-.17.1-.15.1.08.11-.03.16.09.33.92.82.88,1.16,1.21.04.04.16.15.19.3.06.35.65,1.48.73,1.71.04.11.15.16.11.04-.24-.76-.37-1.35-.56-1.96-.01-.04-.03-.16-.05-.22-.06-.23-.26-.41-.67-1.08l.26-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m30.77,74.7c.53,1.23.74,1.48.96,2.8-.03-.04-.09-.09-.12-.17-.26-.9-.98-1.46-1.4-2.37-.02-.04-.03-.24-.22-.37-.3-.24-.53-.22-1.32-.99.05-.07.14-.4.24-.14.29.66.91.68,1.26.97.04.02.12.26.17.39.13.32.62,1.03.71,1.25.04.09.15.11.1,0-.19-.78-.39-.93-.69-1.48-.07-.13.28.04.32.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m29.86,74.73c.49.89.88,1.29,1.14,2.6-.03-.04-.06.06-.13-.16-.25-.74-.91-1.03-1.41-2.12-.06-.13-.13-.05-.24-.13-.46-.36-.44-.05-1.25-.8.04-.06-.06-.33.14-.16.64.56.78.44,1.13.71.02.01.13.04.23.11.33.25.48.92.82,1.25.07.06.16.11.11,0-.32-.76-.38-.59-.76-1.34-.06-.12.19-.01.22.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m29.13,75c.41.62.42.62.78,1.54-.14,0-.16-.02-.19-.08-.32-.62-.52-.61-.89-1.04-.03-.02-.27-.13-.34-.15-.4-.14-.49,0-1.18-.45.02-.05-.03-.35.1-.22.38.39.38.25.68.37.02,0,.29,0,.36.02.28.04.71.48.87.73,0,0,.14.01.02-.14-.38-.49-.09-.26-.52-.67-.05-.05.27.04.29.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m28.27,75.33c.42.41.43.38.83,1.05-.11.02-.12,0-.15-.03-.5-.38-.57-.35-.89-.66-.01-.02-.18-.1-.23-.11-.33-.05-.57.05-1.16-.2.02-.05.05-.28.16-.2.34.25.43.13.67.18,0,0,.13-.01.18-.02.27-.01.64.38.85.51,0,0,.1-.02,0-.12-.36-.33-.04-.07-.41-.33-.05-.03.14-.1.16-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m30.49,73.25c.11.17.37.49.4.63-.16.02-.71-.44-.85-.76-.03,0,.41,0,.44.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m29.34,73.3c.11.17.31.54.58.81-.15.03-.73-.48-.87-.8-.03,0,.23-.04.28-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m28.54,73.72c.13.15.4.4.66.7-.26,0-.66-.36-.89-.61-.03,0,.18-.11.23-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.8,74.32c.07.14.26.27.6.47-.2.03-.66-.19-.84-.4.02-.01.19-.09.24-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.12,74.92c.04.08.14.15.33.26-.12.01-.41-.03-.5-.15,0,0,.14-.11.17-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.38,78.61c.07.28.16.37.18.41.17.24.22.35.41.51.08.05.11.05.24.02.09-.03-.03-.34-.07-.51-.03,0-.07-.03-.12-.04,0,.05.11.27.08.4-.01,0-.03,0-.04.01-.14-.03-.21-.16-.24-.18-.13-.14-.22-.31-.3-.48,0,0-.16-.13-.14-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.8,79.46c-.18.03-.52.07-.6.09-.17.04-.23.05-.34.15-.04.04-.12.12.02.16.05.07.51-.08.73-.06,0-.02-.02-.04-.01-.08-.03-.02-.43.01-.51.03,0,0-.05.02-.06-.04,0-.02.04-.04.06-.06.1-.03.41-.09.62-.05,0,0,.1-.14.1-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.65,78.85c-.08.01-.23.06-.24.08-.12.1-.08.02-.14.11-.03.04-.09.09-.02.29.06.12.41-.02.64.03,0-.03.03-.04.04-.09-.03-.03-.42,0-.5-.02-.06-.06-.02-.01-.04-.11,0-.02.02-.06.03-.08.1-.03.09-.04.31-.1,0,0-.05-.13-.06-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.53,78.72c-.06,0-.34-.05-.34-.05-.09-.05-.07-.02-.11-.07-.02-.03-.17-.17-.16-.22.09-.12.21.02.37-.03,0,.01.03.04.03.08-.01.02-.06,0-.12.01-.13,0-.08,0-.03.09,0,0,.07.03.08.05.07.02.07.01.23.04,0,0,.04.11.05.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.4,79.01c-.1.04-.23.2-.25.21-.18.22-.26.29-.35.52-.03.08-.02.27.11.25.05.08.66-.32.81-.4,0-.03-.05-.06-.08-.11-.06.02-.5.34-.6.33,0-.02-.05-.06-.04-.07-.02-.14.06-.19.07-.22.1-.15.22-.25.37-.38,0,0-.02-.17-.03-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.38,78.19c.05.2.26.43.28.46.14.16.2.19.37.3.07.04.11.04.25,0,.08-.03-.05-.28-.08-.41-.03,0-.07-.03-.13-.04-.01.03.06.15.09.29-.02,0,.05.06-.06.04-.12-.02-.17-.09-.19-.1-.12-.09-.25-.31-.31-.44,0,0-.23-.1-.21-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.93,79.13c-.05-.07-.08-.17-.1-.25-.05-.02-.1-.06-.13-.08l.04.13s.05.1.07.09c.02.04.12.11.13.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.18,79.62c.07-.06.31-.22.39-.25q-.02-.05-.04-.09c-.08.01-.13.04-.19.1,0,0-.08.07-.08.09-.04.02-.1.14-.08.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.02,79.12c-.38.15-.4,0-.48,0-.01-.04-.02-.01-.03-.05.07-.03.2,0,.26,0,0,0,.01.04.22.02.05,0,.03.02.02.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.62,79.32c-.06-.11-.06-.15-.08-.22-.03-.15.14-.37.18-.38.03.04,0,.16.07.32.02.05.14.02.12.14-.11.17-.27.21-.3.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.83,80.06c.09.02.11.03.17.03.11,0,.19-.14.18-.17-.04-.02-.17.06-.24,0-.02-.01-.13,0-.2.04-.1.11.04.1.09.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.63,80.21c.06.02.08.03.12.04.08,0,.14-.1.14-.12-.03-.01-.13.04-.18-.01-.01-.02-.09,0-.15,0-.08.07.02.08.06.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.42,80.38c.06.03.07.02.1.03.07,0,.12-.08.12-.1-.02,0-.11.03-.15-.01-.01-.02-.08,0-.13.01-.08.06.02.07.05.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.47,79.84c-.21-.19,0-.33-.36-.61-.04-.13,0-.12.02-.18.04-.06.23-.12.28-.21-.02.11-.14.45.24.68.01,0,.02.13.11.35-.06,0-.08.03-.13.02-.07,0-.15-.04-.18-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.57,80.09s-.02-.08-.03-.08c-.15-.06-.33-.16-.35-.55-.11-.09-.11-.16-.16-.17-.07-.01-.11.19-.1.25.1.04.16.14.27.42,0,0,.05.06.2.18.06.01.11-.04.17-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.32,80.28s0-.06-.05-.12c-.08-.08-.16-.12-.25-.38-.08-.08-.11-.12-.15-.12-.06-.01-.06.15-.05.2.08.04.45.3.21.32-.07,0,.11.07.17.11q.06.01.11,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.98,78.59s-.07-.11-.09-.18c-.03-.01-.08-.04-.12-.04l.03.1s.04.06.06.06c.02.04.11.08.13.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.73,78.73c.09.03.14.02.18.17,0,.2-.22.36-.41.74-.03.06-.12.04-.15.05-.12-.04-.25-.01-.31-.13,0,0,0-.04,0-.05.08-.1.23-.03.33-.06l-.06-.16c-.03-.05-.16-.05-.27-.03-.07.05-.18.16-.22.26-.03.08.06.23.1.22.08.06.36.16.5.15.05-.01.17.02.27-.16.02-.21.41-.44.38-.85,0-.09-.03-.11-.07-.21-.04-.05-.2-.12-.26-.12l-.03.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.01,77.26c.33.02.67.27.72.38.21.39-.02.91.2,1.2.24.31.58.1,1.02.45.41.31.12.55.77.66.04.03.09.08.14.13-.52.14-.71-.18-.96-.63-.24-.36-.73-.1-1.1-.51-.17-.45,0-.77-.13-1.15-.05-.27-.61-.42-.7-.4-.05.01.06-.09.06-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.85,77.58c.33.02.46.21.52.3.22.38-.09.89.11,1.17.22.31.56.29,1.14.55.45.2.29,1.33,1.48.77.05.04.17.09.21.14-1.1.72-1.49-.3-1.75-.75-.43-.22-.81-.13-1.19-.54-.3-.63.05-.81-.08-1.18-.05-.26-.3-.37-.39-.34-.05.01-.04-.09-.04-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.84,77.23c-.07.15-.2.29-.07.54.01,0,.08.11.09.13-.05.01-.17.01-.23.01-.08-.27-.22-.34,0-.67.1-.07.15-.03.22,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.49,77.21c-.06.15-.2.29-.06.54,0,0,.08.11.09.14-.06.02-.17,0-.23,0-.08-.27-.23-.33-.02-.67.1-.07.16-.02.22,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.15,77.23c-.07.15-.21.29-.07.53,0,0,.08.11.09.14-.05.07-.17.01-.23,0-.11-.16-.23-.2-.24-.32,0-.07.15-.21.23-.35.1-.06.16-.02.22,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.5,80.22c-.07.03-.2.06-.26.14,0,0,.07.54.19.46.05-.03.12-.02.14-.1.05-.01-.03-.32.02-.33,0-.03.18-.09.25-.11.11-.03.21-.17.22-.14.03,0,.1-.03.16-.02-.11.13-.24.48-.38.52-.04.01-.15.14-.14.18.03.11.18.24.29.32.07.01.27-.03.32-.3.08-.06.28-.58.37-.6.02-.06.14-.1.25-.1.21-.02.23.12.29.12.02.09.11.17.38.12.43-.18.46-.07.51-.41.12-.26.04-.23-.02-.32-.09-.06-.19-.1-.3-.1-.35.13-.52.08-.65-.09,0,0-.11.02-.18.04.15.14.23.22.43.23.06.03.28-.05.34.06,0,.22-.09.28-.11.28-.18.06-.24-.09-.31-.12-.06-.03-.45-.17-.48-.22,0,0-.04.22-.22.24-.09.02-.39.67-.47.79-.12.02-.18,0-.13-.06.06-.1.31-.54.35-.6,0-.07-.02-.1-.05-.13-.03-.03-.07-.04-.13-.03-.23.06-.58.33-.68.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.11,80.44c.02.15.08.3.16.46-.07.02-.14.03-.22.07-.08.05-.14.2,0,.29l-.05-.02c-.18,0-.36-.2-.24-.49.02-.1.28-.3.35-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.63,80.94c.09.13.18.21.31.29-.09.11-.17.42.09.41,0,0-.13.05-.13.05-.16.08-.41-.02-.45-.32-.01-.09.11-.41.18-.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m29.3,79.82c-.09.14-.12.21-.11.38.13.04.36.29.14.41,0,0,.14-.02.14-.02.18,0,.33-.23.23-.5-.03-.08-.33-.27-.4-.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m30.53,79.44l-.07-.27-.16.26-.03.14-.22.25-.17-.21.06.32c.04.13-.02.42-.03.51-.05.32-.33.38-.53.37l.02.13c.92-.04.45-.63.78-.99,0,0,.02-.07.04-.09.16-.2.51-.33.66-.3.05.02.04-.13.06-.14-.02-.06-.36,0-.42.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m31.67,80.18l.3-.05c-.12.09-.24.14-.36.23-.13.14-.11.21-.4.43l.28.13c-.15,0-.37.03-.46.04-.13.27-1.08.35-1.06.38l.07.28s-.22-.24-.41-.25c-.19-.02-.46.03-.46.09l.08-.23c.71-.14,1.09-.02,1.74-.49.29-.21.5-.58.46-.72,0-.03.11-.05.15-.1.07.01.12.18.07.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m30.51,80.63c-.13.04-.29.03-.37.08-.11.2.13.2.18.14l.19-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m30.43,80c-.06.13-.17.23-.19.32.08.22.24.05.23-.03l-.04-.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m30.89,79.96c-.08.12-.2.22-.22.29.05.22.22.06.22,0v-.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m31.03,80.45c-.11.03-.24.02-.3.06-.1.17.1.17.14.11l.16-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.93,82c-.11.05-.16,0-.27.02.12.2.21.24.36.15.16.1.17.18.52.3-.07.07-.16.14-.23.2.15.05.37,0,.44-.09.07.07.24.11.41.11.08,0-.15.28-.11.28.19-.03.29-.11.32-.28.03,0,.61-.08.61-.08.01-.07-.02-.08-.02-.2-.73.07-.5.2-1.23-.05-.31-.1-.58-.41-.61-.53-.04-.13.27-.65.38-.7.16-.09.33,0,.62.09.26.08.64.53.78.77l.12-.15c-.11-.19-.15-.28-.19-.34-.06-.06.11-.24-.08-.51-.04.1-.08.19-.12.3-.19-.16-.48-.3-.85-.4-.02-.16-.15-.26-.4-.32l.13.36c-.38.07-.71,1.03-.58,1.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m20.32,82.1c.14,0,.28-.06.37-.03.17.16-.06.23-.13.19l-.24-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m20.17,81.43c.1.11.24.17.27.25,0,.24-.21.11-.23.03l-.05-.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.67,81.39c.09.09.24.15.28.22.02.22-.19.12-.21.05l-.07-.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.68,81.96c.12.02.25,0,.31.04.1.16-.09.17-.13.13l-.18-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.27,82.77c-.06.13-.03.09-.13.18.15,0,.27-.07.38-.22.2-.02.47-.11.62-.12.05.1.01.12,0,.24.17-.06.28-.16.29-.29.12.02.36-.08.5-.19.08-.06.08.24.09.22.13-.16.22-.2.13-.39.02-.01.27-.14.27-.14-.03-.06,0-.14-.08-.25-.63.54-.93.56-1.55.66-.14.03-.59.06-.74.01-.31-.09-.3-.8-.24-.91.08-.19.13-.34.6-.45.3-.07.94.1,1.24.22v-.22c-.25-.09-.33-.15-.41-.16-.08,0-.08-.29-.43-.39.03.11.07.23.1.34-.14,0-.41-.02-.53.02-.07-.14-.36-.18-.51-.16,0,0,.18.23.13.25-.06.03-.15.13-.2.16-.18-.01-.18-.07-.45.05l.28.22c-.2.35-.05,1.44.66,1.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.05,81.66c.15-.03.29-.11.38-.1.19.13-.03.24-.11.21l-.27-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.71,81.62c.13-.07.26-.18.34-.2.23.08.05.25-.04.24l-.31-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.67,81.26c.15.02.31-.01.39.03.15.21-.1.23-.17.18l-.23-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.21,81.72c.13-.07.27-.18.35-.2.24.08.05.25-.05.24l-.31-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.67,82.17c.13-.06.24-.19.31-.2.22.06.05.22-.03.22l-.28-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.33,82.77c0,.15-.02.29-.18.3.21.13.29-.05.4-.2.18.01.37.06.74,0-.03.09-.04.18-.08.29.2-.06.33-.21.31-.3.14.05,1.01-.39.96-.45-.03-.03-.01-.08-.07-.18-.62.37-.45.33-1.19.48-.3.06-.7-.09-.78-.19-.1-.1-.07-.71,0-.79.09-.15.44-.17.41-.21,0,0,0-.21-.03-.2-.08.05-.18.07-.32.11-.1-.13-.11-.14-.36-.08.1.06.14.14.21.2-.3.24-.14,1.24,0,1.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.93,82.08c.13-.05.26-.15.34-.16.21.1.01.24-.06.22l-.28-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.85,81.41c.15.01.57.14.6.25-.01.03-.03.11-.08.12-.14-.1-.31-.18-.51-.18v-.19h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.65,82.12c.13-.05.25-.15.32-.16.21.1.02.23-.05.22l-.27-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.18,82.44c.12-.02.23-.08.3-.07.16.11-.02.19-.08.16l-.22-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.24,81.2v-.13c-.23.02-.34.17-.25.45.08.27.16.4.34.44.19.04.39-.08.38-.49,0-.4-.21-.44-.47-.4v.13c.1,0,.21.12.22.27,0,.15-.06.31-.15.31-.09,0-.17-.14-.18-.29-.02-.14.04-.27.11-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.8,80.86c.04-.09.11-.14.21-.15.08.09.11.18.1.29-.03,0-.05.02-.08.04-.1-.02-.18-.09-.23-.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.15,80.64c.07-.07.16-.08.27-.05.03.11.03.21-.02.3-.03,0-.06,0-.1.02-.08-.07-.12-.16-.15-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.54,80.65c.09-.03.18,0,.26.07-.03.11-.08.19-.16.26-.02-.01-.06-.03-.09-.04-.03-.09-.03-.2,0-.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m31.58,79.22l.12-.16c-.13-.08-.37,0-.51.18-.17.2-.21.45-.08.56.12.1.38.05.55-.15.18-.19.18-.48.04-.59l-.11.15c.07.06.06.24-.04.35-.1.12-.27.16-.35.1-.07-.07-.03-.23.07-.34.09-.11.23-.15.31-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m31.5,78.55c.09-.02.16,0,.23.07-.03.11-.07.18-.15.23-.03-.01-.06-.02-.08-.03-.03-.08-.04-.18,0-.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m31.84,78.69c.09-.01.16.03.22.11-.05.09-.11.16-.2.2-.01-.02-.04-.03-.07-.04,0-.1,0-.19.05-.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m32.21,78.93c.07.05.1.12.08.23-.09.03-.18.05-.27.01l-.02-.08c.05-.08.11-.14.21-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m32.13,78.32c-.07.05-.12.11-.16.21.04.05.09.09.17.11.07-.06.1-.12.13-.2.09.04.18-.08.2-.17.02-.1-.03-.21-.13-.23-.1-.02-.2.03-.22.13,0,.04-.01.11,0,.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.45,80.64l-.11-.07c.13-.2.32-.24.53-.03.2.2.27.32.21.52-.07.2-.28.33-.63.15-.36-.19-.29-.41-.12-.65l.12.07c-.06.09,0,.25.13.33.13.08.32.08.37,0,.05-.08-.04-.22-.16-.3-.12-.07-.27-.08-.33-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.5,79.96c-.09-.03-.17,0-.25.09.03.11.08.19.18.25.03-.02.05-.02.08-.03.03-.1.04-.2,0-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.1,80.17c-.1.02-.16.08-.19.18.08.09.16.14.27.15.02-.03.04-.05.06-.07-.02-.11-.06-.2-.13-.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.75,80.52c-.06.08-.08.16-.04.27.12.03.22.01.31-.03,0-.03,0-.06,0-.09-.07-.08-.17-.13-.27-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.72,79.9c.09.03.14.08.21.16-.03.06-.06.11-.12.15-.08-.03-.13-.09-.18-.14-.09.05-.2-.03-.24-.11-.04-.09-.02-.21.06-.26.08-.04.2-.01.25.07.02.04.05.1.03.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.22,82.05c-.04.15-.14.29-.13.39.12.22.25,0,.23-.09l-.1-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.76,81.23c-.11.11-.28.19-.33.26,0,.27.22.14.25.06l.08-.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m28.43,80.48c-.15.07-.34.09-.43.16-.1.27.19.22.24.14l.19-.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m28.49,81.09c-.16.04-.35.02-.44.08-.15.23.14.25.21.18l.23-.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.76,80.57c-.09.11-.23.18-.27.26.02.25.2.12.22.03l.04-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m28.02,80.21c-.08.03-.19.03-.23.06-.07.14.08.13.11.09l.12-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.72,81.88l-.25-.14c-.05.48.17,1.02.42,1.54.23-.05.64-.18.95-.3-.25-.81.09-.89.6-1.2.12,0,.65-.13.64-.13-.03-.03-.17-.07-.22-.14-.06-.11.16-.29.19-.34.24-.28.21-.64.09-.85-.01,0-.02-.01-.03-.03-.06.06-.16.09-.22.16.16.3.15.42-.34.97-.16.17-.7.51-.81.62-.27.25-.2.48-.13.83,0,.02-.64.17-.64.15-.12-.45-.38-.68-.25-1.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.21,83.68c-.09,0-.22-.09-.24-.21-.02-.13.08-.19.16-.19.07.01.15,0,.16.1.01.05.14,0,.13-.05-.03-.18-.17-.26-.32-.23-.15.03-.33.12-.32.34,0,.1.11.26.17.3.04.47.1.63.37.94-.03.07,0,0-.01.07,0,.08,0,.23.08.33.16.18.34.13.47.05.14-.09.16-.3.06-.45-.05-.08-.17,0-.12.07.06.09.02.16-.03.21-.06.07-.18.09-.25-.02-.06-.12,0-.24.05-.31-.18-.14-.47-.63-.37-.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m28.46,82.7c.07-.06.08-.24.03-.33-.06-.11-.19-.08-.24-.04-.06.06-.1.13-.05.21.04.08-.13.16-.18.08-.09-.14,0-.36.14-.42.13-.08.38-.1.5.06.05.09.08.3,0,.36.26.37.3.48.28.87.08.03.04-.01.09.04.06.06.15.17.14.29,0,.22-.17.3-.33.32-.16.02-.31-.11-.33-.28,0-.09.13-.12.15-.03,0,.1.08.1.16.11.08,0,.15-.05.13-.18-.02-.13-.13-.2-.21-.21.06-.21.01-.67-.27-.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.54,82.97c-.33.05-.68.18-.98.32,0-.04-.07-.09-.06-.2.3-.15.65-.26.98-.33.01.04.05.16.06.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.09,84.88c.73.2,2.24-.47,2.49-.7,0,.04.19-.01.18.09-.28.43-2.47,1.03-2.68.86,0-.04.01-.22.01-.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.03,83.35c.77.47.61.88,1.33,1.25-.05.01-.12.02-.15.05-.79-.43-.75-.92-1.45-1.28.04-.03.21-.11.27-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.51,83.15c.69.45.62.92,1.33,1.3-.05.01-.11.08-.21,0-.75-.46-.68-.89-1.37-1.25.04-.03.14-.06.26-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.33,83.37c.25.07.3.61.95.92-.04.01-.08.05-.15,0-.59-.27-.5-.49-.98-.88.04-.02.1-.05.18-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m30.41,83.08l.03.18c.21-.06.3-.15.26-.41-.04-.21-.17-.33-.35-.3-.17.01-.32.1-.31.34,0,.23.21.4.4.38l-.02-.17c-.08,0-.17-.07-.2-.2-.03-.12.07-.19.16-.17.09,0,.17.05.17.17,0,.11-.04.17-.13.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m31.1,81.41c-.29,0-.5.04-.75.23-.17.21-.02.41.17.42.34,0,.49-.06.73-.41-.19.03-.46.1-.64.11.01,0-.03.12.06.17-.05,0-.09.04-.14-.01-.25-.33.36-.35.65-.4,0,0-.06-.11-.07-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m28.94,82.46c.4-.14.82-.34,1.17-.56.01.04.02.07.04.09-.34.23-.78.45-1.18.61-.01-.04-.02-.11-.03-.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m29.39,83.64c.19-.18.42-.35.62-.45l-.03-.11c-.2.04-.48.19-.69.38.02.03.08.16.1.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m29.9,82.78c-.43.06.09-.38.43-.6-.03-.02-.05-.05-.07-.07-.49.24-1.22.93-.34.82.04.02-.04-.16-.02-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.42,85.46c.19-.23.35-.36.67-.42.26.01.33.28.2.44-.2.27-.36.34-.78.28.14-.12.38-.3.51-.43,0,.02.11.07.09.16.04-.02.1-.03.08-.11-.1-.43-.51.04-.72.23-.01,0-.04-.12-.05-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.46,83.32l.02.18c.21-.06.31-.15.26-.41-.03-.22-.17-.33-.34-.32-.18.03-.32.11-.32.34.01.24.22.41.4.39l-.02-.18c-.08,0-.17-.07-.2-.19-.02-.13.08-.19.16-.19.09.02.17.06.17.18,0,.11-.04.17-.13.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.4,85.01l.03.18c.21-.06.3-.15.26-.41-.04-.21-.17-.33-.35-.31-.17.02-.32.11-.32.34.01.24.22.41.41.39l-.03-.18c-.08,0-.17-.06-.19-.19-.03-.12.07-.19.16-.17.09,0,.17.05.17.17,0,.11-.04.17-.13.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m20.72,83.65c.28-.09.49-.11.79,0,.22.14.15.39-.04.45-.33.11-.49.08-.81-.18.18-.03.47-.03.65-.08-.02.01.05.11,0,.17.04,0,.1.02.12-.04.15-.4-.45-.24-.74-.2,0,0,.03-.11.04-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.53,83.62c.12.27-1.49-.06-1.75.07-.02.05.02.09.03.11.53-.1,2,.35,1.88-.19-.01-.04-.14.04-.15,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.66,83.69c-.27-.04-.63-.21-.84-.29-.02.03-.01.06-.04.09.11.22.61.39.92.33.02-.03-.06-.11-.05-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m25.17,85.16c-.27-.08-.45-.06-.68.07-.02-.03-.05-.1-.06-.13.17-.18.43-.25.71-.12.02.04.03.15.04.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.61,84.36c.05-.2-.37-.28-.84-.28.01-.03.03-.08.04-.11.54-.03,1.35.18.91.51-.01.03-.1-.15-.11-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m24.24,84.93c.46-.54-.99-.34-1.37-.2,0-.03-.03-.08-.04-.11.53-.24,2.09-.38,1.55.38-.01.03-.13-.1-.14-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.06,85.3c.08-.03.15-.05.24-.07.03.28.16.55.31.8-.07.02-.17.02-.22.05-.15-.24-.24-.49-.32-.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.29,86.16c.1.11.14.1.27.08-.24.29-.74.72-.69,1.15-.08-.05-.12-.16-.22-.21,0-.32.41-.68.64-1.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.93,86.05c.07.03.07,0,.22-.03-.11.36-.54.83-.57,1.23-.08-.05-.11-.17-.19-.21-.02-.33.32-.64.54-.99h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m29.48,86.15c0,.08-.21.08-.13.2-.37.04-.69-.22-1.06-.09,0-.1.02-.14.03-.23.3-.14.76.05,1.16.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m29.1,85.57c0,.08-.17.04-.09.16-.37.05-.39-.15-.76-.02,0-.1.04-.14.05-.25.3-.13.4.04.8.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.42,86.41c.05.07.18-.07.18.07.33-.18.19-.36.58-.47-.07-.07-.02-.13-.08-.2-.32.06-.38.3-.67.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m29.38,85.67s-.03.04.02.14c-.14-.01-.15-.03-.28.02,0-.07-.02-.09-.03-.15.05-.07.12-.09.29,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.22,86.68c.03.06.06.03.08.14.12-.09.12-.12.27-.15-.04-.08-.03-.1-.07-.17-.1-.02-.18-.01-.29.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m28.94,86.64c0,.08-.22.06-.14.18-.38.04-.4-.2-.78-.07.01-.11.11-.12.12-.21.3-.14.39.03.8.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m27.95,85.06c-.09.01-.16.03-.25.06.11.26.15.55.14.85.07-.02.16-.06.23-.07,0-.28-.04-.55-.11-.84h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m26.93,85.37c.03.07.04.08.07.15-.29.07-.79.57-.91.77-.01-.02-.28-.29-.38-.37l-.03.21-.33.08-.6-.33.23.45-.21.07-.76-.25.33.34-.28.1-.73-.09.26.21-.52.32,1.06-.34-.17.52.41-.48.54-.16-.18.64.4-.7.41-.13v.5s.28-.68.28-.68l.1-.07.14.15-.5.81-.19.07.04-.55-.22.1-.31.62-.32.06-.09-.16.22-.47-.27.13-.37.4-.36.08.21-.5-.45.15-.02.11-.63.13v-.22s.41-.4.41-.4l-.13-.14.25-.19.72.06-.39-.33.39-.13.65.25-.26-.51.29-.09.61.42.05-.27.25-.02.33.13c.21-.17.65-.38.93-.48h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "22.96 86.38 22.2 86.07 22 85.56 21.8 85.57 21.79 85.81 21.64 85.69 21.45 85.14 20.99 84.95 21.09 85.52 20.83 85.33 20.64 84.74 20.31 84.63 20.38 85.06 19.94 84.77 19.85 84.95 20.02 85.18 20.1 85.26 19.7 85.42 19.63 85.59 19.94 85.58 20.39 85.77 19.74 85.93 20.05 86.13 20.84 86.08 20.97 86.21 20.33 86.54 20.83 86.74 21.49 86.47 21.57 86.69 22.46 86.36 22.22 86.27 21.68 86.44 21.63 86.24 20.91 86.54 20.78 86.49 21.2 86.28 21.3 86.1 20.85 85.88 20.27 85.96 20.74 85.83 20.62 85.55 20.03 85.46 20.27 85.36 20.2 85.12 20.59 85.43 20.55 84.95 20.76 85.55 21.32 85.9 21.2 85.25 21.39 85.42 21.59 86.02 21.88 86.16 21.96 85.84 22.1 86.21 22.9 86.51 22.96 86.38 22.96 86.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m23.08,86.28c-.13-.14-.25-.3-.15-.46,0-.04,0-.08-.06-.14-.12.04-.22.06-.37.2-.05.07-.06.17.03.19.26,0,.37.24.55.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.82,86.65c-.17.06-.36.13-.35.32-.02.05-.04.08-.12.09-.09-.09-.17-.16-.22-.36-.02-.09.02-.18.11-.15.23.14.43-.01.58.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m22.57,85.74c.08-.02.12-.1.1-.18-.02-.09-.11-.13-.18-.11-.09.02-.13.11-.11.19.02.08.1.12.19.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m21.9,87.08c-.07-.05-.06-.16,0-.21.07-.06.16-.06.22,0,.07.05.06.15,0,.21-.07.06-.16.05-.21,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.65,85c-.07-.16-.15-.36,0-.47.02-.05.03-.09-.01-.16-.12,0-.23-.01-.42.08-.07.04-.1.14-.03.18.26.08.28.34.46.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.49,85.41c-.18,0-.39.01-.44.2-.03.04-.07.06-.14.05-.06-.11-.11-.19-.11-.41.02-.09.09-.16.16-.1.18.19.43.11.53.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m19.37,84.03c-.08,0-.16.06-.16.15,0,.08.06.16.14.15.08,0,.16-.05.16-.13,0-.08-.05-.16-.14-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m18.48,85.54c-.03-.07,0-.16.07-.2.08-.04.17-.01.21.07.03.07,0,.16-.07.2-.08.04-.17.01-.21-.07h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "19.84 85.26 19.76 85.09 19.58 85.12 19.05 84.74 18.89 83.87 18.7 83.76 18.56 84.13 18.34 83.16 18.02 83.17 17.98 83.76 17.85 83.72 17.69 83.13 17.5 83.11 17.48 83.52 17.1 83.26 16.98 83.34 17.07 83.42 16.74 83.54 17.06 83.77 16.61 83.94 16.86 84.15 17.5 84.12 17.7 84.2 17.08 84.35 17.23 84.61 17.63 84.64 18.05 84.6 18.23 84.67 17.84 84.79 17.88 84.91 18.29 84.99 19.14 85.08 18.9 84.87 18.26 84.81 18.55 84.69 18.25 84.44 17.4 84.44 18.05 84.25 17.62 83.97 16.98 83.98 17.43 83.89 17.06 83.59 17.3 83.63 17.2 83.47 17.54 83.71 17.61 83.41 17.75 83.88 18.17 84.06 18.2 83.34 18.4 84.18 18.54 84.44 18.76 84.09 18.88 84.84 19.15 85.1 19.52 85.29 19.84 85.26 19.84 85.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.23,82.97c0-.18,0-.39.19-.44.03-.04.05-.08.03-.15-.11-.04-.2-.1-.41-.08-.09.02-.16.09-.1.16.21.18.13.42.29.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m16.76,83.26c-.16-.08-.36-.16-.48,0-.05.01-.09.02-.15-.03,0-.12,0-.22.09-.41.04-.07.15-.1.18-.02.08.25.34.28.36.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m17.31,81.96c-.07-.03-.16,0-.19.07-.04.08,0,.17.08.2.07.03.16,0,.19-.07.04-.08,0-.16-.08-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m15.8,82.94c0-.08.06-.15.14-.15.08,0,.16.06.16.15,0,.08-.07.15-.15.15-.08,0-.15-.06-.15-.15h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "17.08 83.16 16.64 82.52 16.69 82.23 16.64 82.08 16.47 82.16 16.76 81.72 16.67 81.36 16.25 81.66 16.31 81.47 16.62 80.96 16.58 80.63 16.16 81.01 16.17 80.82 16.33 80.51 16.16 80.22 16.02 80.32 15.86 80.59 15.74 80.39 15.54 80.61 15.7 81.23 15.3 80.99 15.28 81.39 15.77 81.89 15.3 81.89 15.42 82.21 15.7 82.23 16.02 82.35 16.03 82.52 16.53 82.71 16.48 82.52 16.17 82.43 16.21 82.24 15.62 82.07 16.04 82.04 15.97 81.8 15.43 81.29 15.88 81.52 15.71 80.63 15.87 80.81 16.14 80.54 15.96 81 16.03 81.34 16.37 81.03 16.05 81.64 16.19 81.87 16.57 81.69 16.29 82.11 16.41 82.34 16.58 82.29 16.48 82.52 16.54 82.71 16.95 83.19 17.08 83.16 17.08 83.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m28.09,85.07c.29-.09.94-.07,1.23-.02.39,0,1-1,2.25-1.42v.02s.09-.01.12,0c-.68.22-.93.83-1.89,1.34-.04.09.03.04.07.06.8-.09,1.04-.71,1.76-1.24.02,0,.11-.09.26-.08-.26.41-1.11,1.34-1.92,1.57-.28.06-1.41-.13-1.83-.04-.02-.07-.02-.08-.03-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m31.06,83.41c-.06-.03-.18-.02-.26,0-.26.12-.47.34-.69.46-.37.2-.47.55-.79.93-.1.03-.2.03-.31.06.02.07.12.08.14.1.12.03.27.02.35-.07.57-.57,1.11-.97,1.75-1.3-.05,0-.11-.01-.16,0-.09-.05-.47.19-1.37.9,0,0,.01-.02,0-.03.26-.26.24-.38.47-.48.27-.12.62-.49.86-.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m31.89,84.37c-.07-.03-.14-.06-.22-.05-.34.16-.38.47-1.13.87-.04.01-.13.12-.25.16-.13.05-.3.09-.36.11,0,.07.07.06.18.1.12.02.17.02.24.02.75.01,1.27-.84,1.91-1.16-.05,0-.11-.01-.16-.02-.43.03-1.19,1.01-1.46.95,0-.02-.11-.02,0-.07.29-.12.72-.69,1.24-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m32.43,83.49c-.08-.03-.16-.04-.25-.03-.03.06-.03.13,0,.2.08.03.15.03.23.03.02.1.15.12.25.1.09-.04.16-.12.13-.23-.03-.1-.13-.16-.22-.13-.05.01-.11.04-.13.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m31.53,82.91c0,.09.03.16.08.24.03,0,.05.08.08.07s.07-.12.1-.15c0-.08-.04-.14-.08-.21.08-.06.04-.19-.03-.27-.06-.07-.18-.09-.26-.02-.07.07-.08.19-.01.26.03.03.07.08.12.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m31.81,83.43c.05-.3.15-.41.42-.59.48-1.3.85-1.47,1.23-2.28.08.2,0,.27-.02.3-.22.53-.49.43-.95,1.68.02.11.06.03.1.02.56-.78.94-1.34,1.06-1.93.1.14.12.31-.02.63-.22.5-.5.84-.87,1.35-.17.29-.86.57-.74.87-.09.01-.11-.02-.21-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m32.67,80.59c-.14.49-.4.75-.49.86-.39.48-.07.81-.08,1.26.1-.1,0-.17.15-.28.26-.72.2-.49.5-1.04.05-.08.07-.44-.02-.34-.46,1.06-.55,1.06-.53,1.16-.01-.02-.12.13-.06-.07-.07-.5.17-.61.19-.64.22-.29.23-.39.34-.58.07-.1,0-.3,0-.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m33.95,81.11c-.23.6-.8,1.38-.91,1.5-.03.03-.03.07-.09.13-.07.1-.32.24-.37.28.03.05.17-.01.29-.02.12-.02.14-.04.22-.07.28,0,.49-.25.72-.58.17-.26.32-.54.43-.87,0-.01-.01-.19-.04-.27-.22.75-.6,1.06-.87,1.44-.07.06-.22.07-.1-.07.48-.54.51-.69.7-1.21.02-.05,0-.22.02-.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m34.36,80.23c-.08,0-.16.03-.24.08,0,.06.02.13.07.18.09,0,.15-.03.23-.07.05.08.18.04.26-.02.08-.06.09-.18.03-.26-.06-.08-.19-.09-.26-.02-.04.02-.07.07-.08.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m33.17,80.07c.04.08.1.14.18.19.02-.01.07.05.09.04.03-.03.02-.14.04-.18-.05-.07-.1-.11-.16-.16.05-.08-.04-.19-.13-.23-.09-.04-.21,0-.25.09-.04.09,0,.2.09.24.04.02.1.03.14.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m33.7,80.55c-.07-.3-.02-.43.16-.7-.21-1.4.17-2.29.28-2.32-.23.72.06.34-.19,1.7-.01.33.14.14.16.12.21-.44.16-1.41.14-2.18.14.07.27.35.26.67,0,.55.08,1.13-.26,1.59-.04.34-.57.87-.35,1.1-.08.04-.12.02-.22.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m33.46,77.65c-.2.72-.49,1.53.22,2.05.06-.12,0-.17-.07-.39.11-.73.13-1.69.11-1.64-.1.39-.16.91-.23,1.44-.01,0-.08.24-.08.04-.14-.64.13-.97.05-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m34.9,77.65c-.41.37-.09.67-.4,1.62-.08.13-.17.4-.25.56.05.04.15-.08.26-.13.09-.08.27-.26.32-.31.16-.41.36-1.38.19-1.72-.02.8-.19,1.44-.24,1.52-.25.27-.26.41-.13-.02.21-.69.07-1.12.25-1.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m34.66,76.74c-.08.03-.14.08-.21.15.02.06.05.12.12.15.07-.03.13-.08.19-.14.08.07.2-.01.25-.1.05-.08.03-.2-.06-.25-.09-.06-.2-.03-.25.05-.03.04-.05.11-.04.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m33.61,76.94c.06.07.13.1.23.12.02-.01.09.02.1,0,.01-.03-.03-.14-.03-.19-.06-.06-.12-.08-.21-.11.03-.09-.1-.17-.19-.17-.1,0-.2.06-.21.17,0,.09.07.19.17.2.04,0,.1,0,.15-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m34.08,77.12c.02-.36-.04-.45-.02-.71-.58-1.12-.51-2.16-.4-2.22.3.58-.02,1.03.31,1.6.08.28.2.15.24.06-.46-1.57-.03-.67-.39-1.71.31,0,.6,1.55.49,1.85.06.3-.22.5-.09,1.04-.06.07-.04.05-.14.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m32.89,74.55c.32,1.29.07,1.15.95,1.74.03-.11-.04-.19-.16-.36-.25-.44-.22-.97-.44-1.04.17.33.11.52.29.99-.01,0-.06.15-.11-.03-.35-.49-.16-.68-.52-1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m34.33,74.37c-.05.44.12.67.16,1.55-.04.05-.19.5-.1.67.03-.15.09-.32.19-.41.08-.09.22-.19.27-.25.15-.45-.13-1.37-.38-1.62.36,1.01.28,1.34.24,1.43-.17.3-.1.14-.09.04.05-.65-.16-1.09-.29-1.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.43,79.16l.5-.1v.02s-.2.07-.2.07c-.04.02-.09.05-.13.1-.04.03-.07.09-.07.15,0,.06,0,.13.03.22v.08s.03.11.03.11v.02s0,0,0,0l.64-.13-.02-.11-.03-.1s-.03-.06-.07-.07c-.03-.01-.08-.02-.13-.02h-.14s0-.01,0-.01l.68-.13h0s-.11.05-.11.05l-.06.02s-.02.01-.05.02c-.02.01-.04.03-.06.06-.01.02-.02.06,0,.08l.03.2.75-.16-.02-.06v-.08s-.03-.06-.03-.06c-.03-.15-.08-.24-.14-.29-.06-.04-.12-.07-.15-.08-.02,0-.04,0-.05-.02,0,0-.03,0-.05,0h-.12s-.13.02-.13.02h0s.57-.13.57-.13l.07.34.1.43.06.34h-.03s-.04-.21-.04-.21h-.01s-.02-.01-.02-.01l-1.4.28s0,.1.02.18v.05s0,0,0,0l-.23-1.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.39,78.37c.02-.07.07-.12.12-.16-.03-.05-.09-.09-.16-.12l.17-.02.21-.02h.17c-.1.02-.18.05-.22.07-.05.02-.09.04-.14.09-.05.04-.08.1-.11.16-.03.07-.04.13-.03.19,0,.04.01.09.05.14.03.06.07.09.12.12.06.01.1.02.13.02.03,0,.07-.03.11-.08.04-.05.08-.13.11-.22l.12-.3c.03-.1.08-.17.14-.23.06-.06.14-.09.24-.09h.06c.14,0,.24.04.29.13.06.08.09.16.1.22,0,.1,0,.17-.03.23-.04.05-.07.1-.08.11l-.05.05s.05.05.1.07l.11.05-.61.06v-.02c.13-.04.25-.09.34-.16.1-.07.16-.14.18-.22.02-.09.02-.14.02-.18,0-.09-.04-.16-.12-.22-.07-.05-.13-.08-.21-.07-.04,0-.09.02-.12.06-.03.04-.07.1-.1.18l-.12.3c-.04.11-.09.2-.15.27-.07.06-.14.1-.23.1-.06,0-.14,0-.24-.03-.09-.03-.15-.12-.18-.27,0-.09,0-.16.02-.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.97,76.64h0s0,0,0,0h0c-.12.01-.21.03-.26.03l-.12.03s-.06.03-.11.05c-.04.02-.07.06-.09.09-.03.05-.04.09-.04.12v.03s0,.06,0,.06l.44.02.58.04.44.02.02-.24h.02s-.04.66-.04.66h-.02s.01-.22.01-.22l-.44-.02-.58-.04-.44-.02v.04s0,.04,0,.04c0,.03,0,.07.02.11.02.04.05.07.09.11.03.03.08.06.13.09.06.02.11.04.19.05l.16.03v.02s-.63-.05-.63-.05l.06-1.11.62.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.8,75.61l.65-.07.6-.07.04-.18h.01s.01.01.01.01l-.04.18-.04.23-.04.18h-.01s-.01-.01-.01-.01l.05-.21h-.15s-.19.03-.19.03h-.15s-.09.45-.09.45l.15.08.16.09h.02c.06.03.12-.05.14-.21h.03s-.1.5-.1.5h-.03c.03-.12,0-.2-.09-.24l-.42-.23-.55-.29-.28-.15v-.02s0-.03,0-.03c0-.01.02-.01.03-.02l.28-.03h0Zm.47.14l-.29.03-.22.03.19.1.26.13.19.1.08-.41-.22.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m14.96,74.02c.02-.07.07-.12.12-.16.06-.05.13-.08.21-.1.08-.01.17-.02.26,0,.09,0,.18.02.27.05.09.04.17.07.23.1.06.03.12.08.16.12.05.05.09.1.11.15.03.05.05.12.06.21.01.09,0,.18-.03.29l-.2.57h-.02s.08-.23.08-.23l-.43-.15-.54-.19-.43-.15-.07.21h-.02s.25-.72.25-.72h0Zm-.09.33l1.38.48.06-.18c.03-.08.04-.15.03-.23-.02-.08-.09-.15-.21-.23-.12-.07-.27-.14-.43-.19-.18-.07-.33-.09-.43-.1-.1,0-.18.04-.22.08-.05.03-.08.08-.1.14l-.07.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m15.6,72.71c.07-.04.14-.06.23-.07.08,0,.17,0,.27.03.11.02.2.06.29.1.07.04.15.09.21.14.07.05.11.11.15.17.05.06.07.13.08.22.01.09,0,.17-.04.26-.03.06-.06.11-.1.14-.02.03-.06.05-.11.06-.04.02-.11.03-.25.05-.13.01-.29-.02-.48-.13-.17-.09-.3-.2-.38-.37-.08-.16-.09-.31-.01-.47.03-.06.08-.11.15-.14h0Zm-.15.34s.03.09.07.13c.04.04.11.09.21.16.1.07.2.13.3.18.08.05.16.08.22.11.07.02.11.04.16.05.05,0,.07.01.1.01.02,0,.04,0,.05,0h.04s.04-.03.08-.04c.04-.02.06-.05.09-.09.03-.05.03-.1.03-.15-.01-.05-.03-.1-.05-.13-.02-.04-.05-.07-.08-.09l-.27-.15-.19-.11c-.19-.09-.33-.16-.41-.17-.09-.02-.16,0-.21.02-.05.02-.08.05-.11.1-.03.07-.04.12-.03.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m16.16,71.77c.06-.04.13-.05.2-.05,0-.06-.02-.13-.05-.2l.14.1.18.11.14.09h0c-.1-.02-.18-.05-.22-.06-.05-.02-.1-.02-.16-.02-.07,0-.14.03-.2.06-.06.03-.11.07-.14.12-.02.04-.04.08-.05.15-.02.06,0,.11.03.16.03.04.06.08.08.09.03.01.08.02.13,0,.07-.02.14-.05.24-.1l.27-.16c.1-.05.18-.08.26-.08.08-.01.16.02.24.08l.05.03c.11.09.16.18.15.3-.01.11-.03.18-.07.23-.05.07-.11.13-.17.15-.05.02-.1.04-.13.05h-.07s.02.08.03.13l.05.11-.51-.33h0c.12.04.25.07.37.07.12,0,.22-.02.28-.06.07-.05.11-.09.13-.13.05-.07.06-.15.05-.24-.02-.09-.06-.16-.13-.2-.04-.02-.08-.03-.13-.02-.05,0-.11.03-.19.07l-.28.16c-.11.06-.2.09-.29.11-.09.01-.17-.02-.25-.06-.05-.03-.1-.08-.16-.17-.05-.08-.05-.19.03-.32.04-.07.1-.13.15-.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m17.92,69.73c-.12.11-.14.21-.07.28l.75.73c.08.07.1.16.08.25-.02.1-.06.18-.13.25-.05.04-.1.09-.16.12-.05.02-.11.05-.17.06-.05,0-.1,0-.16,0-.05-.02-.09-.04-.12-.08l-.82-.8-.15.15h0s0-.02,0-.02l.44-.44v.02s-.14.16-.14.16l.9.88s.07.05.12.05c.05,0,.1,0,.14-.03.05-.02.08-.05.11-.08.06-.06.09-.12.11-.18.03-.06.03-.11,0-.16-.01-.05-.04-.09-.08-.12l-.03-.04-.3-.29-.23-.22-.16-.16c-.08-.08-.17-.07-.26.02l-.02.03h-.02s-.01,0-.01,0l.38-.38v.02h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m18.49,69.27l.35.18.45.23.35.17-.54-.78c-.06-.08-.15-.08-.27,0v-.02s.39-.28.39-.28v.02c-.11.1-.15.18-.1.25l.78,1.13-.03.02-.42-.21-.53-.27-.42-.21.65.94c.05.08.11.09.16.08.07-.02.1-.03.11-.04l.05-.02v.02s-.12.1-.12.1l-.17.12-.13.1-.02-.03.05-.03.04-.03s.03-.06.02-.1l-.03-.1s-.02-.05-.04-.08c-.02-.04-.07-.11-.12-.18l-.52-.76c-.03-.05-.11-.03-.24.06l-.02-.03.31-.22h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "19.97 68.35 19.98 68.37 19.79 68.48 20.52 69.75 20.7 69.65 20.72 69.68 20.17 69.99 20.15 69.96 20.34 69.86 19.61 68.58 19.43 68.68 19.42 68.66 19.97 68.35 19.97 68.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m20.87,67.95c.06-.03.13-.04.2-.02.07.01.14.04.21.1.06.04.13.11.19.18.05.07.1.15.13.23.04.09.07.17.09.24,0,.07.02.14.03.21,0,.06-.02.13-.04.18-.03.06-.06.12-.12.19-.05.07-.13.12-.24.17l-.56.23v-.03s.2-.09.2-.09l-.17-.41-.22-.53-.17-.41-.2.08v-.03s.69-.29.69-.29h0Zm-.31.15l.57,1.36.18-.07c.07-.03.13-.08.18-.14.05-.05.06-.16.03-.3-.03-.15-.08-.29-.14-.45-.07-.18-.14-.31-.23-.39-.07-.07-.14-.11-.2-.12-.06,0-.12,0-.18.03l-.21.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m22.3,67.59c.07.02.14.06.19.12.07.05.13.13.17.22.04.09.09.19.12.28.01.09.03.18.04.25,0,.08,0,.16-.03.23-.02.07-.05.13-.11.2-.05.07-.12.11-.22.14-.07.02-.12.02-.16.02-.04,0-.09-.02-.12-.04-.04-.02-.1-.07-.21-.16-.09-.09-.18-.24-.23-.44-.04-.19-.04-.37.02-.53.06-.17.17-.28.33-.32.08-.02.14,0,.21.02h0Zm-.36.11s-.05.09-.05.15c0,.05,0,.13.02.25.01.12.04.25.07.36.03.09.06.17.07.23.03.06.05.11.07.15.02.04.04.06.05.08,0,.02.02.03.03.03.01,0,.02.01.04.02.01,0,.04.02.07.04.04,0,.09.02.13,0,.06-.02.1-.05.13-.09.03-.04.06-.08.07-.11.02-.06.02-.09,0-.12l-.05-.3-.05-.22c-.05-.2-.1-.34-.15-.42-.05-.08-.1-.13-.14-.15-.06-.02-.11-.02-.16,0-.07.02-.12.05-.16.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m23.35,67.32c.07.02.13.06.17.12.04-.04.07-.1.11-.17l.03.16.02.21.02.17c-.05-.1-.08-.17-.1-.22-.02-.04-.05-.09-.1-.13-.05-.05-.1-.08-.17-.11-.07-.02-.14-.02-.2-.02-.03,0-.08.02-.14.06-.05.03-.08.07-.1.13-.02.06-.02.1-.02.13s.04.06.09.1c.05.04.13.08.23.11l.3.1c.09.04.17.08.23.13.07.05.1.14.11.23v.06c.01.14-.02.24-.11.31-.1.06-.17.1-.23.1-.09.01-.16.01-.22-.02-.06-.03-.11-.05-.12-.07l-.05-.04s-.05.05-.07.1l-.05.11-.09-.61h.02c.04.14.09.24.18.33.08.1.15.15.24.17.07.01.14.01.17,0,.09,0,.16-.05.21-.12.05-.07.07-.15.06-.23-.01-.04-.03-.07-.07-.1-.04-.03-.11-.06-.19-.09l-.31-.11c-.11-.04-.21-.09-.27-.14-.07-.05-.11-.13-.12-.22,0-.06,0-.14.02-.24.02-.1.11-.16.26-.2.09-.01.16,0,.22.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m25.92,67.22h.16s.12,0,.12,0v.03s-.21-.02-.21-.02l-.05,1.47.21.02v.02s-.62-.03-.62-.03v-.02s.23.01.23.01l.06-1.41-.15.47-.21.64c-.04.11-.06.18-.08.23-.02.04-.03.07-.04.09l-.02-.09s-.03-.07-.04-.11l-.13-.52-.12-.48-.06-.25-.05,1.3s0,.04.01.05c.01.02.03.02.04.03.01,0,.02,0,.03.01l.09.02h.06s0,.02,0,.02h0s-.16,0-.16,0h-.21s-.16-.02-.16-.02v-.02c.16,0,.23-.02.23-.09l.02-.39.02-.49.02-.39s-.01-.05-.04-.06c-.02-.01-.05-.02-.09-.03h-.11s0-.04,0-.04l.46.02.05.21.1.39.08.38.04.18h0s.11-.35.11-.35l.16-.44.11-.35h.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m27.67,67.61l-.13.5h-.01s.02-.23.02-.23c0-.05,0-.1-.02-.16-.02-.05-.06-.1-.1-.12-.06-.03-.13-.06-.21-.08l-.08-.02-.11-.02h-.01s-.01-.01-.01-.01l-.17.63.11.03.09.03s.08,0,.1-.03c.03-.04.05-.07.07-.12l.06-.13h.01s-.17.67-.17.67h-.01s.01-.12.01-.12c0-.03,0-.04,0-.05s0-.03,0-.05c0-.03,0-.05-.02-.08-.02-.03-.03-.04-.07-.05l-.2-.05-.19.74.06.02.08.02.06.02c.15.03.25.03.32,0,.07-.04.11-.07.14-.1.01-.02.03-.04.04-.05,0,0,.02-.01.03-.04l.04-.11.05-.12h.01s-.14.58-.14.58l-.34-.08-.43-.11-.33-.09v-.02s.21.05.21.05h0s.02-.02.02-.02l.36-1.39s-.09-.04-.17-.06h-.04s0-.03,0-.03l1.06.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m29.08,68.15c-.13-.05-.23-.04-.28,0l-.13.12-.17.14-.13.12.03.3.04.38.03.3.16.05v.03s-.19-.06-.19-.06l-.22-.09-.18-.06v-.03s.24.09.24.09l-.02-.24-.03-.3-.02-.24-.14.13-.17.15-.14.12s-.03.04-.04.05c-.02.06.03.11.17.17v.02s-.15-.06-.15-.06l-.19-.07-.15-.06h.02c.12.03.24.02.33-.06l.14-.12.19-.17.14-.12-.03-.26-.04-.33-.03-.26-.15-.06v-.02s.55.21.55.21v.02s-.22-.08-.22-.08l.02.2.04.25.02.19.12-.1.15-.13.12-.1s.02-.03.03-.04c.01-.02,0-.05-.03-.07-.02-.01-.07-.04-.13-.07v-.02s.46.18.46.18v.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "29.97 68.57 29.95 68.6 29.76 68.49 29.06 69.78 29.25 69.89 29.24 69.92 28.69 69.62 28.69 69.6 28.88 69.69 29.58 68.39 29.39 68.3 29.41 68.27 29.97 68.57 29.97 68.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m30.55,68.93c.07.05.13.16.15.31l.09-.03.1-.03h0s0,.02,0,.02l-.3.45h-.01c.07-.26.1-.43.05-.53-.04-.09-.09-.15-.13-.17-.05-.04-.11-.04-.18-.03-.08.02-.15.06-.22.12-.08.06-.15.15-.23.25-.01.02-.03.05-.05.08-.02.04-.04.07-.07.12l-.09.16s-.05.09-.06.14c-.02.04-.04.09-.05.16-.01.06,0,.14.06.22.02.03.04.04.07.06.04.02.08.04.12.04.08,0,.15-.02.21-.05.06-.04.12-.06.15-.09.03-.03.07-.05.11-.09.03-.03.07-.06.1-.09h.01s-.34.53-.34.53c-.01-.02-.02-.04-.02-.05,0-.02,0-.04,0-.07v-.08s0,0,0,0h-.01c-.14.04-.25.04-.33-.02-.07-.05-.13-.12-.17-.2-.02-.09-.03-.2-.02-.34.01-.15.07-.29.18-.44.09-.14.17-.23.25-.27.07-.03.14-.07.17-.08.04-.02.07-.03.1-.04.03-.02.07-.02.12-.02.05,0,.11,0,.17.04l.05.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m31.55,70.11l-.27.59-.25.56.14.13h-.02s0,.02,0,.02l-.14-.13-.17-.16-.14-.13h0s0-.01,0-.01l.16.14.07-.13.09-.18.06-.13-.32-.3-.16.08-.15.09-.03.02c-.04.05,0,.12.11.23v.02s-.39-.35-.39-.35h.02c.09.06.18.08.26.03l.41-.24.54-.32.27-.16h.02s0,.03,0,.03c.01,0,0,.02,0,.03l-.12.26h0Zm-.36.33l.12-.26.1-.2-.19.11-.25.15-.18.12.31.28.09-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m32.6,70.74l-.15.37-.18.48-.14.36.72-.61c.08-.07.07-.16-.02-.28h.02s.32.36.32.36l-.03.02c-.1-.12-.18-.14-.25-.09l-1.04.89-.02-.03.17-.44.22-.56.17-.44-.87.74c-.06.06-.08.11-.06.17.03.06.05.1.06.11l.03.04-.03.02-.1-.12-.13-.16-.1-.12h.02s.04.03.04.03l.03.04s.06.03.1.02c.05-.01.08-.02.1-.04.03,0,.04-.02.07-.05.04-.02.1-.07.18-.14l.7-.59s.01-.11-.09-.23l.03-.02.25.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m33.64,72.34c0,.07-.02.15-.05.22-.04.08-.09.16-.16.23-.07.07-.16.14-.23.19-.08.04-.16.08-.24.1-.08.03-.15.04-.23.05-.07,0-.15-.02-.23-.05-.08-.04-.15-.09-.2-.17-.04-.06-.06-.11-.06-.16-.01-.04-.01-.08,0-.12.01-.03.04-.11.09-.24.06-.12.17-.23.35-.35.17-.1.34-.15.51-.14.18,0,.32.08.41.23.04.06.05.13.04.2h0Zm-.21-.31s-.1-.02-.16,0c-.05.01-.13.05-.24.09-.11.04-.21.1-.31.17-.09.05-.16.09-.21.14-.05.03-.09.08-.12.1-.03.04-.05.07-.06.08-.02.01-.02.03-.03.04,0,0,0,.03,0,.04,0,0,0,.04,0,.08-.01.03,0,.08.03.12.03.05.06.08.12.1.05.02.09.03.13.03.04,0,.08,0,.12-.02l.27-.13.19-.11c.17-.11.29-.2.36-.27.06-.07.1-.13.1-.18,0-.05-.02-.1-.04-.14-.04-.06-.08-.1-.14-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m34.18,73.32c0,.06-.02.13-.06.19.06.03.12.05.21.06l-.15.07-.2.09-.14.07c.08-.07.14-.13.17-.16.03-.03.07-.08.1-.13.03-.06.05-.12.05-.2,0-.07,0-.14-.03-.2-.02-.03-.05-.07-.1-.11-.04-.05-.1-.07-.15-.06-.06,0-.1,0-.13.02-.03,0-.06.05-.07.11-.03.06-.03.14-.03.25l-.02.32c0,.1-.02.19-.05.26-.03.07-.1.13-.2.18l-.05.02c-.14.05-.24.04-.33-.02-.08-.06-.14-.13-.16-.18-.04-.08-.06-.16-.05-.22.01-.06.02-.11.04-.13l.02-.07s-.07-.02-.12-.03l-.12-.02.55-.27v.02c-.11.08-.19.17-.26.27-.07.1-.1.19-.09.27.01.08.03.14.05.17.03.08.1.14.18.17.09.03.16.03.23,0,.04-.02.07-.06.08-.1.02-.05.03-.11.03-.21l.02-.32c0-.11.02-.21.05-.29.04-.08.09-.15.17-.19.05-.02.13-.04.23-.04.1,0,.19.05.27.18.03.08.05.15.05.22h0Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-20",
    transform: "translate(17.37 94.75) rotate(-15.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Gobierno del Estado"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.34,
    y: 3.2
  }, "de Michoa"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 8.66,
    y: 3.2
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.98,
    y: 3.2
  }, "\xE1n de O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 18.9,
    y: 3.2
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 20.22,
    y: 3.2
  }, "ampo"))), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m107.6,155.8c-2.81,1.75-8.24,3.47-11.47,3.4-5.64,5.62,10.6-.99,11.47-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m87.23,103.65c-.35-1.63-3.3-1.4-2.15-2.61,2.37-2.4-3.43-.12-1.27-1.95,3.34-2.57-2.51-.76-1.35-2.17-2.6-3.04-6.53-4.32-8.56,1.1-2.8.68,1.49,1.22-1.98,3.07,5.24,3.05-2.49.43,1.74,3.81-2.64,2.09.43,6.71,3.12,3.61-4.21-.97,1.48-3.2,3.06-3.23,4.71-3.48,6.69,5.6,7.4-1.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m110.45,108.99c4.1-4.9-3.57-8.64-2.01-5.64-2.96,5.85,1.63,2.93,2.01,5.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m55.1,123.85c-5.97-2.21-1.26-9.26-1.08-5.89,5.48,3.61.05,3.35,1.08,5.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m84.3,90.56c-4.66-1.36-10.18-.44-10.17,1.44-2.3,1.33-11.04,2.43-4.48,2.36-.4.41-2.54.43-2.13,1.64.87,1.45,4.13-3.52,4.18.35.79.09,4.06-3.49,4.41-1.02.56-.06,4.21-1.85,4.51-3.36-.04,1.52-.01,2.75.82.76,1.89.07-1.75-3.29.13-1.1,1.06.38,1.89.33.28-.25-1.49-2.08,2.59,1.76,2.47-.8m-1.76.27c-.54.14-.74-.57-.19-.71.57-.16.76.55.19.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m60.14,99.59c.74,1.99,3.29,11.45,2.98,3.92-4.87,1.36,2.98-1.52.05-2.56,4.37-2.25,5.38,7.66,1.51,2.89,3.88,1.43-1.39-4.48-.8.34,6.5,6.41,7.22-7.67-3.74-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m58.98,102.04c1.5,3.04.72,2.06-3.27,2.62,2.4-2.23,1.4-1.06,3.27-2.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m55.43,105.1c6.95-1.9,5.41,3.52,13.55,3.79-2.71,3.88-11.5-4.02-13.55-3.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m46.68,106.07c.31.75,2.73,3.56.04,3.94,2.4.94,1.32.78-1.74.77.81-2.51,2.68-1.75,1.69-4.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m51.31,110.51c-1.33-.8-4.75,1.74-4.25,2.53,1.07.19,4.04-1.99,4.25-2.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m46.86,105.58c7.18,3.16,27.17,4.68,16.12,5.38-10.63-.61-11.11,2.33-16.12-5.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m81.71,112.28c-13.23-8.95-8.36,5.96-17.84.87,5.67,1.43-1.24-6.57-1.75,3.95,3.91-2.37,14.29-6.63,19.59-4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m94,90.5c.59,2.67,2.44,10.6-.62,4.89,4.85-1.25-3.34.17-1.32-2.19-4.92.25-.84,9.33.14,3.26-2.66,3.19-1.05-4.57.86-.1-2.44,8.81-10.1-3.02.94-5.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m96.24,92.04c.22,3.39.4,2.15,4.15.63-3.19-.72-1.73-.22-4.15-.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m100.83,92.91c-6.95,1.83-2.91,5.76-9.82,10.07,4.28,2.01,7.97-9.26,9.82-10.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m108.89,89.37c.13.8-.56,4.45,1.95,3.43-1.63,2-.76,1.33,1.88-.2-1.94-1.77-3.17-.18-3.82-3.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m107.11,95.53c.75-1.36,4.98-.88,4.95.06-.83.7-4.5.29-4.95-.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m108.49,89.03c-4.62,6.33-21.15,17.65-11.25,12.72,6.04-3.47,11.87-4.76,11.25-12.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m97.84,102.46c8.84-3.48,9.83-9.76,11.83-.74-3.86-1.05-3.89-3.09-2.6.93-7.83-2.01-.33-.49-3.17,1.34,3.3,2.48-4.93,1.59-6.06-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m109.31,97.23c8.38,14.86-3.68,12.07,1.76,13.79-2.59,1.71-3.86-.75-5.25,6.45,5.79-5.41,5.95-6.49,9.08,2.39-1.47-9.5,5.82-21.27-5.58-22.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m111.44,114.12c-6.2,5.22-4.24,7.01-2.66,13.13.74-6.58,6.38-8.08,2.66-13.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m107.04,125.13c4.78,16.12,13.27-3.82,4.85,3.55-1.63.85-2.13-1.67-.14-2.75,13.88,1.79-5.55,15.77-4.71-.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m113.05,128.78c-.35-1.25,1.65-1.8,1.98-.53.37,1.29-1.65,1.82-1.98.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m62.76,111.87c-9.38,1.42-13.4-3.54-10.63,5.29,2.83-2.85,1.81-4.62,2.73-.5,3.42-2.65,3.12-4.97,2.06-.07,2.37-.42.76-.93.98,1.72,4.42-3.76,3.69-1.18,4.86-6.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m50.2,113.09c.16,16.93,9.15,8.67,5.37,12.82,3.11.18,2.99-2.6,7.78,2.95-7.69-1.8-8.39-2.62-6.63,6.61-3.51-8.95-15.67-15.5-6.52-22.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m56.81,128.78c7.98,1.42,7.22,3.93,8.89,10.03-3.95-5.31-9.57-3.79-8.89-10.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m66.13,136.11c3.91,16.35-13.38,3.33-2.43,5.51,3.87-2.83-5.84-3.51-4.36,1.47,4.66,8.93,11.34-.53,6.79-6.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m62.75,142.28c-.32-1.28-2.33-.72-1.98.53.33,1.29,2.35.76,1.98-.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m81.71,112.28c6.91-14.37,10.22.98,15.85-8.17-4.2,4.07-2.18-6.32,3.5,2.55-4.55-.09-15.69,1.4-19.34,5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m132.82,169.31c-1.47,1.88-6.56,4.19-5.88,6.17,1.26.74,7.17-6.58,5.88-6.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m112.95,186.14c-.5.38-.79.65-.79.65-.13-.05,1.49,0,.79-.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m121.96,181.23c-1.99,1.18-6.77,2.4-7.12,4.33.89,1.26,8.02-4.13,7.12-4.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m110.65,185.04c-.9.41-1.91,1.57-1.83,1.41-.28-.08,2.63-.45,1.83-1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m110.05,182.72c-.22.26-.74.93-.79,1.02.23-.22,1.57-.48.79-1.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m120.05,174.97c-2.22,1.42-9.01,4.34-8.15,7.07,1.94-1.19,8.86-6.44,8.15-7.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m113.09,192.98c-2.26-.18-4.57,4.09-1,3.27,1.15-1.79-3.33-.55-.66-2.07,1.41-.07,2.39,2.67.73,3.03-5.01-1.45-.58-2.62-6.06-6.93-6.5,2.59,14.67,12.49,6.99,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m99.65,189.27c-3.04.93-7.14-2.02-9.19-3.61,2.31,1.24,6.96,2.21,9.19,3.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m107.86,189.53c1.5-1.76,5.47-2.88,7.63-2.05-1.9.88-5.55,1.91-7.63,2.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m99.37,190.08c-8.01.56-19.01-2.48-26.4-5.98,7.57,3.11,18.98,4.45,26.4,5.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m95.22,188.95c-3.5.17-9.27-2.4-12.27-3.91,3.09,1.03,9.88,1.93,12.27,3.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m98.79,191.06c-10.92.7-25.55-3.51-34.74-8.18,9.49,4.37,24.32,6.72,34.74,8.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m97.72,192.01c-10.37.82-21.94-2.24-31.23-6.44,9.45,3.84,21.4,5.09,31.23,6.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m96.95,192.54c-1.05,1.36-7.18,2.03-7.78,2,.51-.23,6.47-2.98,7.78-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m93.46,192.59c-1.4,1.21-8.18,1.17-8.86,1.07.61-.16,7.53-2.23,8.86-1.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m89.3,192.42c-2.95,1-8.88.21-11.71-.11,2.79-.14,9.16-1.25,11.71.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m107.32,187.51c.84-.24,1.18,1.07.34,1.28-.81.23-1.16-1.07-.34-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m106.55,188.39c-.24-.29-1.14.81-1.01.6-.14-.08,1.59.1,1.01-.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m114.65,184.23c-1.84,1.28-6.87,1.69-6.19,4.11,2.06-.42,6.72-4,6.19-4.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m113.7,185.18c.84-.24,1.19,1.05.34,1.27-.81.23-1.15-1.06-.34-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m111.45,184.13c.81-.23,1.17,1.08.35,1.3-.84.23-1.18-1.09-.35-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m117.69,181.66c.83-.24,1.18,1.06.34,1.27-.82.23-1.16-1.07-.34-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m116.95,182.61c-.63.51-1.02.87-1.02.87-.2-.05,1.64-.24,1.02-.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m125.82,175.1c.83-.23,1.17,1.06.34,1.27-.82.23-1.18-1.06-.34-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m128.75,175.12c-2.7,1.98-9.22,4.06-9.93,6.91,2.32-.26,10.55-6.34,9.93-6.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m105.18,185.68c.79-.24,1.16,1.06.34,1.27-.86.25-1.19-1.07-.34-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m104.63,186.99c-.21.42-.31.67-.31.67-.05-.02,1.05-.4.31-.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m110.05,181.16c-1.29,1.18-5.21,3.25-3.76,4.9.95-.27,7.62-7.67,3.76-4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m110.78,181.65c.8-.24,1.17,1.06.34,1.27-.84.23-1.17-1.07-.34-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m116.3,179.54c.83-.24,1.18,1.07.34,1.27-.81.23-1.16-1.06-.34-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m120.47,178.8c-2.54.85-12.23,7.62-5.56,4.7,1.19-.83,12.16-8.05,5.56-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m115.6,180.63c-.27.49-.58.66.15.35.23-.05-.11-.2-.15-.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m123.06,175.78c.82-.23,1.17,1.08.34,1.28-.84.24-1.19-1.07-.34-1.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m125.04,176c-.71.43-.88,1.05-1.54,1.4-.2-.1,2.73-.42,1.54-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m121.3,174.11c.82-.23,1.18,1.06.34,1.27-.84.23-1.17-1.06-.34-1.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m120.61,175.21c-.14.18-.49.73-.48.74.32-.16,1.16-.21.48-.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m128.07,168.47c-1.68,1.47-6.88,4-5.64,6.03,1.31.55,6.79-5.65,5.64-6.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m103.76,187.57c-.67-.11-1.11,2.91-.45,3.02,3.29-.02,2.11-2.13.45-3.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m102.89,188.04c-1.14-1.18-1.49,4.33-.22,2.49-.02-.23.46-2.35.22-2.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m101.77,188.34c-1.16-1.18-1.48,4.32-.24,2.5-.02-.23.46-2.36.24-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m100.64,188.64c-.93-.97-1.4,2.81-.71,2.85.75.07.8-2.44.71-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m97.21,192.68c-2.81,1.95-7.55,2.91-4.15,5.51.32-.18,6.92-7.74,4.15-5.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m108.45,189.67c3.42.27,7.98-1.25,6.36,2.69-.36.02-9.86-3.24-6.36-2.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m101.82,191.22c-5.88,2.59-.04,7.43-3.83,9.91-1.61.55-2.11-2.32-.85-2.98.68-.51,1.7.72.61.76-2.07,1.24,1.77,2.34,1.04-.61-11.6-1.23,2.94,11.17,3.03-7.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m106.35,186.43c.82-.23,1.17,1.08.34,1.29-.82.24-1.18-1.08-.34-1.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m105.69,187.59c-.24.31-.39.5-.39.5-.08,0,.84-.2.39-.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m115.53,180.44c-2.29,1.42-8.56,3.69-8.05,6.37,2.6-1.7,5.97-3.9,8.05-6.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m122.29,176.72c-.27.33-.5.61-.68.85-1.6,1.41,1.91-.17.68-.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m123.13,174.84c-1.78,1.15-7.37,2.89-5.66,5.3,1.84-.89,6.3-4.63,5.66-5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m132.69,165.02c-1.85,3.73-9.3,7.85-8.51,11.14,2.68-1.24,10.12-10.08,8.51-11.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m84.3,105.39c.78.88-8.44,3.34-8.23,2.21-.77-.89,8.45-3.38,8.23-2.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m81.93,113.12l-19.79,5.31,12.9,48.08c2.51,9.36,16.68-.83,22.51,4.84,2.18-7.82,19.54-6.09,17.03-15.45l-12.9-48.08-19.76,5.3Zm8.76.1c-.05-2.74.47.72,2.09-.56-.83.69-.86,1.41-.11,2.18-1.53-.29-4.1-.91-1.98-1.62Zm-8.52,2.29c.06-1.44.03-1.45.8-.21,2.55-.89-.51.69,1.17,1.84-1.47-.28-4.14-.93-1.97-1.63Zm-8.53,2.29c-.03-2.74.47.72,2.1-.56-.83.69-.84,1.41-.1,2.18-1.48-.27-4.16-.94-2-1.62Zm-8.67,2.33c-.05-2.74.48.71,2.1-.56-.83.69-.86,1.41-.11,2.19-1.47-.28-4.24-1.01-1.98-1.62Zm3.24,12.08c-.05-2.75.48.72,2.1-.56-.82.69-.87,1.4-.12,2.16-1.52-.31-4.08-.78-1.98-1.6Zm3.1,11.55c.2-2.24,1.38.14,1.98,1.6-1.48-.32-4.32-.92-1.98-1.6Zm1.81,11.89c1.39-.69,3.93-1.67,2.54.14,1.05,1.91-1.09.73-2.54-.14Zm7.7,12.8c-.9-.57-1.58-.37-2.08.56.89-1.84-2.59-1.64.09-2.16-.01-2.76.46.72,2.1-.56-.82.69-.86,1.4-.11,2.17Zm8.26-.26c-1.54-.26-4.11-.91-1.98-1.61.2-2.22,1.38.15,1.98,1.61Zm8.8.1c-1.52-.29-4.1-.89-1.97-1.6.25-2.15,1.36.09,1.97,1.6Zm7.63-4.51c-1.48-.24-4.14-.93-1.97-1.61-.05-2.73.46.72,2.08-.56-.82.69-.85,1.4-.11,2.17Zm-2.1-4.11c-29.53,19.34-28.39-19.03-34.86-37.14,0,0,29.7-7.97,29.7-7.97-1.57,5.03,19.53,45.95,5.17,45.11m9.4.19c-1.49-.26-4.12-.92-1.98-1.61-.04-2.75.46.72,2.09-.56-.82.69-.86,1.4-.11,2.17Zm-1.92-12.2c-1.51-.28-4.11-.93-1.98-1.62-.04-2.74.48.72,2.1-.56-.82.69-.86,1.41-.12,2.18Zm-3.83-12.68c1.08,1.94-1.21.68-2.55-.13,1.07-.07,1.51-.63,1.36-1.69.35,2.05,3.06-.2,1.18,1.82Zm-3.1-11.55c1.11,1.96-1.25.67-2.55-.13,1.07-.07,1.51-.63,1.36-1.69.35,2.05,3.06-.2,1.18,1.82Zm-3.24-12.07c1.05,1.93-1.13.72-2.55-.14,1.07-.07,1.51-.63,1.36-1.68.35,2.04,3.06-.21,1.18,1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m70.46,168.08c3.82,1.61,2.5-12.36-1.12-8.67,1.17,2.6,1.11,5.68,1.12,8.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m72.09,169.65c-1.51-1.94-3.09-.74-2.26-5.4-9.79,6.28-4.42,17.15,2.26,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m70.57,181.85c-1.41-3.11-3.15-11.77-5.68-2.48.41,4.34,14.71,4.42,5.68,2.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m71.32,180.66c-1.72,1.28,2.17.92,2.45,1.33.2-1.22-1.83-1.45-2.45-1.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m88.94,179.49c-1.57-.72-.49,1.17-.4,1.15.36.13,1.64-.75.4-1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m117.69,156.19c3.23-2.23-2.04-5.71-1.69-9.31-5.33-.48.63,6.6,1.69,9.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m118.76,157.12c11.63,6.85,10.84-5.29-.77-5.8,3.08,3.62,1.06,3.38.77,5.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m127.36,159.92c-6.82-2.08,2.66,7.56-3.71,9.5,3.22.25,9.95-8.1,3.71-9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m125.35,167.14c.92-2.22-3.11.31-1.91,1.52.14-.59,1.37-.92,1.91-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m109.07,174.08c-.86.97.7,1.09.95.79.07-.03.05-2.2-.95-.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m93.78,96.78c-.15,2.82-2.76,4.65-5.22,5.94-2.06.11,2.26-3.51-1.53-1.68.47,6.06,10.09-2.57,6.75-4.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m71.68,107.76c1.7-4.5-3.69-2.19-.8-1.28,2.38,2.78-5.79-1-2.97,1.22-7.55-5.68-6.1,2.28,3.77.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m75.09,175.57c-.47-1.05-.83,1.16-.13.79.28-.15.12-.52.13-.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m77.74,175.13c-.49.13-.47,2.47-.02,2.61.43-.32.48-2.29.02-2.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m82.89,175.57c-.54.24-.44,2.39.07,2.74.49-.27.32-2.32-.07-2.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m87.62,179.93c1.5-7.53-23.11-10.12-17.04.51-1.26-2.35,18.74.64,17.04-.51m-15.27-1.47c-.16-.83-1.81-2.65-.61-1.54.97-3.36,1.4.57.61,1.54m1.76-.22c-2.05,1.08-1.41-4.58-.11-2.8-1.36.35-.42,2.28.11,2.8m1.14-.08c-.91-2.68-.05-.35-.95.06-.7-5.22,2.09-2.6.95-.06m1.64-.05c-2.21.96-1.13-5.1,0-2.95-1.42.16-.56,2.38,0,2.95m.84.02c-1.06.42-1.1-3.89.06-3.4.94.09.93,3.37-.06,3.4m2.02.13c-2.31.76-1.11-5.35.02-3.05-1.47,0-.62,2.38-.02,3.05m1.88.2c-.05-3.14-1.25-2.16-1.69-.19-.77-4.54,3.22-2.82,1.69.19m1.35.25c-1.13-.11-1.24-3.61-.08-3.55.91.22,1.21,3.65.08,3.55m2.15-2.39c-1.87-1.29,1.8,4.48-1.28,1.86-.13-1.52,1.18,1.82.99-.22-1.52-.8-1.07-4.07.3-1.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m123.75,160.91c1.64-2.74-16.76,7.38-14.32,7.17,1.86,8.5.81,5.69,8.62.71,9.57-4.76,7.64-2.96,5.7-7.88m-11.7,10.73c-1.61.1-.08-.33-.05-.72-2.46-4.11.91-1.42.05.72m1.12-.84c-2.12-1.05-2.14-4.17-.16-.34-1.78-3.88.38-2.47.16.34m1.05-.78c-2.27-.77.64-.04-.28-1.05-3.37-2.03.18-2.82.28,1.05m.79-.65c-.28-1.58-2.61-2.54-1.03-3.27-.26.91,1.5,2.42,1.03,3.27m.67-.45c-.26-.99-1.77-2.32-1.35-3.07.34.97,1.81,2.3,1.35,3.07m.89-.51c-2.49-.65-1.07-3.85-1.19-2.54-1.25,1.48,2.53,1.65,1.19,2.54m.54-.42c-.31-.98-1.82-2.31-1.41-3.06.32.93,1.86,2.35,1.41,3.06m1.12-.66c-1.04-.44-1.16.16-2.13-2.66.63-.43,2.47,2.23,2.13,2.66m1.24-.6c-2.23-.93.47,0-.36-1.01-1.19-.09-2.49-2.96-.6-1.62.43,1.02-.28-.04-.59-.02-.5.91,2.75,1.5,1.55,2.66m1.02-.48c-.83.18-2.39-2.43-1.73-3.01.8-.1,2.32,2.44,1.73,3.01m1.05-.45c-1.2.43-2.95-4.46-.93-2.55-2.28.79,2,1.81.93,2.55m.6-.27c-.32-.84-1.95-2.43-1.36-2.96.21.93,1.85,2.42,1.36,2.96m1.22-.42c-1.1-.53-1.31.09-2.14-2.68.67-.25,2.49,2.41,2.14,2.68m.37-.12c-.33-.79-1.91-2.4-1.32-2.85.09,1.58,3.11,2.78,1.32,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m122.31,164.33c.78-.13-.56-1.12-.72-1.67.22.57.46,1.13.72,1.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m117.24,166.6c.72-.31-.56-1.19-.78-1.74.26.58.52,1.15.78,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m119.28,163.77c-1.01-.51.42,1.46.69,1.99,1,.46-.45-1.45-.69-1.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m79.96,126.33c2.29-.01.1-3.3,1.18-4.58-1.74,1.2-3.96,5.43-1.18,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m81.61,122.2c.78-.5.75-.66.54-1.51-.36,0-1.74,2.31-.54,1.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.71,122.28c-1.14-.9-2.89,2.43-.94,1.83,2.14.71,1.12-4.78.94-1.83m-1.27.6c-.21.12-.32-.12-.12-.22.19-.1.31.11.12.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m81.18,125.07c.16,2.19,2.06.53,1.53-.87-1.03-.04-1.32.29-1.53.87m.91.18c-.02.35-.45.34-.44,0,0-.34.45-.33.44,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.32,134.72h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.32,134.71s0-.01,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m89.06,140.99c.28-4.7-4.37-3.96-7.59-4.06-.95-.9,6.49.1,6.47-.12-.95-3.37-4.4-1-5.27-4.19-.18-7.28,4.97,2.65,2.12-3.63-3.49-1.43-4.39-3.64-8.65-2.46.34-1.18.81-.65.97-1.23-.69-.41.94.1-.06-.29-.17-.42.61.22.22-.17-1.96-.97-1.67,4.76-5.39,5.08,1.99,2.48,5.93-5.23,2.85,3.58.97,3.42,2.87,6.92.79,10,.13.23,5.87-9.04,5.67-7.11-10.89,9.5,3.02,11.39.13.64.48,5.75,2.91,5.88,7.74,3.97Zm-12.52-16.09c.63.09.02,0-.07.22-.17.14-.13-.15.07-.22m1.68,14.25c.05-.5-.37-1.27-.47-1.68,1.39.82,1.28.59.47,1.68Zm.68-7.45c1.52,1.22,5.11,2.75,2.28,3.76.48-1.28-.92-2.76-2.28-3.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m96.2,175.4c-.6-.28.57,2.55.47,2.63.76-.13-.08-2.28-.47-2.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m95.23,177.39c.83-.01-.24-1.26-.31-1.9.09.64.2,1.27.31,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m90.16,175.42c-.42-.18-.08,1.27.35,1.06.21-.21,0-1.02-.35-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m92.98,175.89c-.59-1.02-.52.66-.08.79.44,0,.1-.53.08-.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m90.47,176.83c-.71.22.96,2.1.38.32-.06-.2-.18-.28-.38-.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m102.93,173.51c-.67-.82-.21.78-.14.99.49-.13.24-.64.14-.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m101.86,175.8c.12-.06.23-.11.36-.17-.76-2.14-.72-1.92-.36.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m106.45,170.85c-.24.45.25,2.69.8,2.47.04-.62-.22-2.31-.8-2.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m104.67,169.32c-4.96,8.94-22.55-2.14-17.01,9.99,18.16,5.05,29.02-14.76,17.01-9.99m-15.15,8.73c-1.48.47-2.23-3.16-1.51-3.28.22,1.46.46,2.64,1.51,3.28Zm.48.09c-.95-.41-.72-2.27-1.13-3.25.91.42.64,2.29,1.13,3.25m.95-1.88c-.2.58.28.77.37,1.43-1.42,2.84-2.62-6.08-.37-1.43m1.04-.7c-1.08-.31-.26,2.63.66,2.52-.85,2.19-2.86-4.89-.66-2.52m1.79,2.95c-.63-.98-2.18-.52-1.16-3.31.84.28,1.4,3.22,1.16,3.31m.68.02c.07-1.48-2.17-3.72-.19-3.35-.61.62.89,2.89.19,3.35m1.59-.07c-.95-.81-1.31-.32-1.46-3.31.79-.13,1.97,3.11,1.46,3.31m.95-.08c-1.26.38-1.9-5.35-.22-2.76-.02.48,1.13,2.66.22,2.76m.94-1.64c-.23.43-.74-.15-.55-.47.22-.43.71.15.55.47m1.72,1.1c-1.16,1.27-1.92-3.27-1.49-3.23.35.83.5,3.41,1.49,3.23Zm.17-3.3c-1.26.67.42,1.53.11,2.79,1.56,1.62-2.99-3.66-.11-2.79Zm1.25.24c-1.41-1.65-.56,1.92.11,2.16.44-.7-.89-1.37-.23-1.61,1.52.89-.31,3.63-.69.48-.78-1.12.24-3.16.8-1.02Zm1.53,1.91c-.59-1.61-.45.12-.86.39-1.3-4.36.84-3.84.86-.39m1.09-.57c-.46-.82-1.84.41-1.12-3.2.87-.06,1.22,2.82,1.12,3.2m1.25-.76c-2.17,1.55-1.52-6.3-1.06-1.49,1.14-.58-.57,1.74,1.06,1.49Zm1.35-.94c-.65-2.48-.92,0-1.22.85-1.26-2.29,1.69-5.47,1.22-.85m.97-.67c-.89.48-1.65-2.79-.94-3.27.92-.48,1.68,2.75.94,3.27m1.14-.94c-2.13-.44.57-.25-.06-1.17-1.91-.06-1.06-3.58-.08-1.46-2.2-.32,1.57,1.15.14,2.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m69.32,123.01c6.84,23.68,7.06,57.65,39.07,31.92-10.25-28.67.24-47.8-39.07-31.92Zm33.63,14.25c-17.3,8.76-14.9-5.66-18.92-17.5,17.3-8.76,14.9,5.66,18.92,17.5Zm-13.9,3.73c-17.29,8.76-14.89-5.67-18.91-17.5,17.29-8.76,14.89,5.67,18.91,17.5Zm-8.47,21.41c-3.53-12.34-8.15-19.25,8.63-20.79,3.04,12.22,10.81,25.19-8.63,20.79m22.02-3.95c-11.16,10.59-9.32-11.51-12.75-17.02,0,0,13.26-3.56,13.26-3.56-.4,4.69,10.19,20.13-.51,20.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m88.06,149.65c-1.39.08-2.16.56-1.47,2.04,1.37-.31,2.39-.43,1.47-2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m86.55,145.45c-2.1-.56.03,3.61-.1,4.32,2.5.37.02-3.36.1-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m79.67,147.3c-2.11-.56.03,3.6-.1,4.32,2.53.36.03-3.34.1-4.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.49,150.33c1.75.22.69-4.69-.84-3.6-.09,0,.82,3.74.84,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m83.03,152.66c.12-.5-1.18-.15-.84.22,0,0,.84-.22.84-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.88,151.47c.3-.52-.97-.1-.81.22,0,0,.81-.22.81-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m83.22,150.42c.4-.29-.84.17-.76.2,0,0,.76-.2.76-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.6,153.69c.07.39.78,0,.98,0-.06-.39-.78,0-.98,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m83.47,154.44c.08.1.8-.15.9-.17-.07-.1-.81.15-.9.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m85.11,152.86c-.8.55-1.51-1.17-.8-1.6.8-.55,1.52,1.17.8,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m86.4,152.94c-.06-2.73-2.25-3.96-3.36-1.79-.04,2.84,2.4,3.88,3.36,1.79Zm-1.08.31c-1.36.87-2.38-2.13-.96-2.49,1.19-.31,1.91,1.91.96,2.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m85.64,153.87c-.43.24.16.11.27.06-.07-.06-.2-.2-.27-.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m84.73,150.05c.22-.39-.14-.1-.31-.11.03.15.19.08.31.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m83.91,153.64c-.1.15-.63.26-.79.3-.01.09,1.38-.09.79-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m83.27,154.34c.12-.09,1.12-.13.9-.45-.13.09-1.08.13-.9.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m83.42,152.98c-.05-.45-.81-.02-1.05,0,.02.48,1.11.26,1.05,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.53,153.58c.09-.05.98-.18.93-.36-.08.05-.99.18-.93.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.93,151.59l-.87.23c-.05.15,1.29-.1.87-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.26,152.39c-.22.14.72-.19.71-.16.8-.61-1.08-.47-.71.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m84.15,154.47c.1.17,1.62-.31.56-.4,0,.29-.33.35-.56.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m83.23,150.54l-.9.24c-.04.32,1.27.03.9-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.38,151.2c.26-.17.88-.02.93-.33-.06.03-.97.21-.93.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m83.46,150.13c.29.26.56.05.44-.2-.41.07-1.48.46-.44.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m83.24,154.52c-.3-1.14-.2,0-.08.31.06-.12.42-.26.08-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m84.47,154.45c-.06-.91-.43.05-.72.19,0,0,.72-.19.72-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m87.08,155.48c.4.88,1.78,2.2.98,3.04,3.56.52,1.38-7.78-.98-3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m89.88,151.09c-4.38-.6-5.32,7.5-.98,2.13,2.81,8.05,2.92,2.77.98-2.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.46,159.51c.19-.88-2-.29-1.41.38,0,0,1.41-.38,1.41-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.22,157.48c.48-.87-1.66-.16-1.4.38,0,0,1.4-.38,1.4-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.78,155.7c.64-.52-1.41.27-1.28.34,0,0,1.28-.34,1.28-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m81.72,161.28c.13.67,1.34.02,1.7-.01-.12-.68-1.34-.01-1.7.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m83.21,162.51c.14.22,1.36-.23,1.54-.25-.15-.22-1.35.23-1.54.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m86,159.86c-1.36.9-2.56-1.99-1.37-2.72,1.37-.92,2.57,2,1.37,2.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m88.19,160c.07-3.94-3.54-7.08-5.71-3.03.03,4.69,3.84,6.67,5.71,3.03Zm-1.84.52c-2.31,1.47-4.04-3.6-1.64-4.25,2.02-.52,3.23,3.26,1.64,4.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m86.88,161.55c-.62.47.27.19.47.13-.13-.1-.32-.32-.47-.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m85.34,155.09c.36-.66-.21-.21-.52-.21.05.25.33.15.52.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m83.96,161.19c-.18.25-1.09.42-1.36.51.02.16,2.29-.18,1.36-.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.89,162.38c.22-.16,1.85-.21,1.5-.77-.21.16-1.86.21-1.5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m83.13,160.06c-.1-.79-1.39-.05-1.82-.02.11.78,1.79.48,1.82.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m81.59,161.08c.15-.09,1.67-.31,1.59-.62-.15.09-1.67.31-1.59.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.3,157.7l-1.49.4c-.07.24,2.22-.18,1.49-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m81.15,159.06c-.17.18,1.47-.34,1.52-.47.32-1-2.01-.29-1.52.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m84.37,162.59c.15.28,2.74-.49.94-.68-.01.49-.56.6-.94.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.79,155.91l-1.51.41c-.1.57,2.2.05,1.51-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m81.37,157.07c.31-.22,1.4-.13,1.5-.4.4-.45-1.68.3-1.5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m83.18,155.21c.48.44.96.17.75-.33-.61.1-2.57.79-.75.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m84.79,154.57c0,.25.51-.02.62-.02.05-.28-.55,0-.62.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m81.43,154.41c1.69,3.61.15-2.85-.38-2.92-2.76-.66-1.23,6.59.38,2.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m100.69,144.11c4.6-5.28,4.18,8.11,6.64,12.2,1.8-1.08-4.88-22.45-6.64-12.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m104.19,147.22c-1.7-4.89-7.57-1.4-10.99-.77-3.77,7.97,8.09.33,10.99.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m106.04,155.66c-2.98-20.16-21.87,6.01-4.99,2.86,7.54-1.15,5.84-2.93,4.05-9.27-2.93-4.42,1.31,6.26.94,6.4Zm-3.77-2.79c3.89.9,3.95,4.13-.76,4.18-.05-1.27-2.38-4.98.76-4.18m-.18-2.92c1.3-.59,1.73,2.28,1.72,2.5-1.74.65-3.65-1.22-1.72-2.5m-5.75,2.64c.06-3.32,4.18.61,1.3,1.32-1.25.87-.88-.35-1.3-1.32Zm5,5.23c-.1.34-4.17,1.36-4.53,1.45.96-.38,3.56-2.37,4.53-1.45Zm-.18-.68c-4.03,1.33-4.41,1.7-3.94-2.68,3.1-2.34,3.32,0,3.94,2.68Zm-.96-4.22c-1.4.59-1.96-1.79-.62-2.31,1.45-.24,2.15,2.12.62,2.31m2.03,4.89c-1.92-1.02,3.25-.9,4-1.23.55.24-4.06,1.14-4,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m103.59,139.68c-1.18.45-4.52.54-3.98,2.57,1.02-.76,6.86-.54,3.98-2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m94.76,159.69c1.88.71-1.87-8.41-1.56-8.71-.93,1.05,1.34,7.55,1.56,8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m94.34,123.77c3-.78,2.72-1.8-.26-.98-2.99.79-2.73,1.81.26.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m93.38,122.18c.2.74,1.21.46,1.01-.27-.19-.75-1.21-.49-1.01.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m94.56,121.53c.03,1.26,1.7.36,2.25.76.55-.94-.86-.97-2.25-.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m93.06,122.27c-.36-.83-2.31,1.11-1.93,1.16-.01.57,2.37-.63,1.93-1.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m96.37,121.05c.36-.3.62-2.1.47-2.17-.1-.06-1.5,2.4-.47,2.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m95.57,121.02c.26-.36.06-2.21-.13-2.25-.11,0-.8,2.59.13,2.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m94.68,121.12c.23-.4-.35-2.42-.59-2.44-.11.05-.2,2.78.59,2.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m93.68,121.33c.5-.18-.6-2.98-.79-2.96-.18.08.27,3.03.79,2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m92.72,121.64c.86-.11-.59-2.42-.73-2.4-.18.13.34,2.17.73,2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m91.9,122.01c.95-.19-.91-2.08-1.01-2.02-.14.14.61,1.83,1.01,2.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m91.25,122.42c1.04-.63-3.18-2.95-.78-.58.28.27.58.46.78.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m92.15,131.3c3.01-.79,2.73-1.8-.26-.98-3,.78-2.72,1.8.26.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m91.18,129.71c.19.74,1.22.47,1.01-.27-.19-.74-1.21-.46-1.01.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m92.37,129.08c.03,1.27,1.68.35,2.24.76.56-.95-.84-.97-2.24-.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m90.88,129.8c-.42-.78-2.31,1.1-1.94,1.17,0,.57,2.39-.62,1.94-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m94.17,128.59c.36-.31.63-2.09.47-2.17-.11-.05-1.49,2.35-.47,2.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m93.36,128.57c.27-.35.07-2.22-.1-2.27-.14.01-.8,2.57.1,2.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m92.49,128.65c.24-.38-.36-2.42-.57-2.42-.14.04-.21,2.78.57,2.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m91.49,128.85c.51-.18-.6-2.98-.79-2.94-.17.06.26,3.06.79,2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m90.53,129.18c.86-.08-.58-2.42-.72-2.38-.18.11.32,2.17.72,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m89.73,129.54c.94-.17-.91-2.07-1.03-2.02-.14.14.61,1.85,1.03,2.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m89.07,129.95c1.01-.62-3.16-2.93-.79-.57.29.25.56.46.79.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m97.87,136.81c3-.78,2.73-1.8-.26-.98-2.99.79-2.72,1.8.26.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m96.91,135.22c.19.75,1.21.47,1-.27-.19-.74-1.21-.47-1,.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m98.1,134.58c.05,1.26,1.68.35,2.23.77.57-.95-.84-.97-2.23-.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m96.6,135.3c-.39-.79-2.3,1.11-1.92,1.17,0,.57,2.37-.62,1.92-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m99.89,134.1c.37-.29.62-2.1.47-2.17-.1-.06-1.49,2.35-.47,2.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m99.1,134.07c.27-.36.06-2.23-.14-2.26-.12.01-.78,2.59.14,2.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m98.2,134.16c.25-.39-.33-2.42-.56-2.43-.15.05-.21,2.74.56,2.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m97.22,134.37c.5-.21-.6-2.98-.79-2.96-.18.07.26,3.05.79,2.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m96.26,134.68c.86-.1-.59-2.41-.74-2.38-.17.13.34,2.17.74,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m95.46,135.05c.9-.19-.91-2.08-1.03-2.02-.14.13.59,1.85,1.03,2.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m94.78,135.47c1.01-.37-1.44-1.73-1.5-1.64-.08.16,1.06,1.52,1.5,1.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m88.53,159.41c-.31.88.38.31.82.29.64.33.27,3.23,1.64,2.45-1.8-4.08,2-3.87,2.05-.03,3.54-2.3-4.07-6.49-4.51-2.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m92.75,162.1l-.76-2.83c-2.32-.14-1.12,3.58.76,2.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m87.75,161.56c.73,2.23,2.85.25,1.53-1.54-1.41.13-1.25.55-1.53,1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m87.74,162.55c-.09-.67-.27-.81-.91-.53-.05.7.34.7.91.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m80.6,162.41c-.11.95,4.3,1.23,6.02.03-2.14.93-5.12.37-5.19-1.9-1.48-1.25-.62-3.32,0-4.88-1.64-2.12-2.28,5.41-.83,6.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m86.11,142.48c-1.63.2-1.22.43-.48,1.45-.36,3.3,1.95-.24.48-1.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m82.22,143.53c-2.07.24-.71.52-.48,1.66-.23,3.05,1.91-.66.48-1.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m79.25,144.33c-.2.05-1.92.19-1.1.72,1.01,3.32,2.15,1.9,1.1-.72"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 29.65,
    y: 106.2,
    width: 103.88,
    height: 1.56,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-24.94 24.81) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 30.39,
    y: 108.96,
    width: 103.88,
    height: 1.56,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-25.63 25.09) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 31.12,
    y: 111.69,
    width: 103.88,
    height: 1.56,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-26.31 25.38) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 31.86,
    y: 114.45,
    width: 103.88,
    height: 1.56,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-27 25.66) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 32.6,
    y: 117.21,
    width: 103.88,
    height: 1.56,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-27.69 25.95) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 56.14,
    y: 130.74,
    width: 60,
    height: 2.81,
    rx: 0.87,
    ry: 0.87,
    transform: "translate(-31.31 26.85) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 39.76,
    y: 146.78,
    width: 59.94,
    height: 1.56,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-35.87 23.12) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 40.5,
    y: 149.54,
    width: 59.94,
    height: 1.56,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-36.56 23.41) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 41.24,
    y: 152.3,
    width: 59.94,
    height: 1.56,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-37.25 23.69) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 41.98,
    y: 155.06,
    width: 59.94,
    height: 1.56,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-37.94 23.98) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 42.71,
    y: 157.79,
    width: 59.94,
    height: 1.56,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-38.62 24.26) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 43.45,
    y: 160.55,
    width: 59.94,
    height: 1.56,
    rx: 0.48,
    ry: 0.48,
    transform: "translate(-39.31 24.55) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 95.87,
    y: 52.68,
    width: 35.15,
    height: 5.31,
    rx: 1.64,
    ry: 1.64,
    transform: "translate(-10.47 31.3) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 97.84,
    y: 60.02,
    width: 35.15,
    height: 5.31,
    rx: 1.64,
    ry: 1.64,
    transform: "translate(-12.3 32.06) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 22.87,
    y: 48.58,
    width: 133.05,
    height: 175.02,
    rx: 16.6,
    ry: 16.6,
    transform: "translate(-32.22 27.83) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-24",
    transform: "translate(43.13 110.38) rotate(-15.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DOC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 15.64,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.67,
    y: 0
  }, "MEN"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 36.59,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 40.1,
    y: 0
  }, "O DI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 54.53,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    x: 59.89,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 61.99,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 65.32,
    y: 0
  }, "AL")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m117.25,134.04c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m118.59,133.68l-.23-.87c-.03-.13-.17-.21-.3-.17l-.64.17c-.13.03-.21.17-.17.3l.23.87,1.11-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m122.79,132.55c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m124.13,132.19l-.23-.87c-.03-.13-.17-.21-.3-.17l-.64.17c-.13.03-.21.17-.17.3l.23.87,1.11-.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 125.07,
    y: 130.61,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-29.71 37.05) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m117.48,133.97l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 117.61,
    y: 133.8,
    width: 1.15,
    height: 1.15,
    transform: "translate(-30.79 35.23) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m119.76,134.55c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m119.12,134.72c-.13.03-.26-.04-.3-.17l.06.24.24-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m119.93,133.31c-.13.03-.21.17-.17.3l.23.87,1.11-.3-.3-1.11-.87.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 120.94,
    y: 132.91,
    width: 1.15,
    height: 1.15,
    transform: "translate(-30.45 36.06) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 122.05,
    y: 132.61,
    width: 1.15,
    height: 1.15,
    transform: "translate(-30.33 36.34) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m124.37,133.06c.03.13-.04.26-.17.3l-.87.23-.3-1.11,1.11-.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m117.84,135.32l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m117.84,136.25c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 117.91,
    y: 134.91,
    width: 1.15,
    height: 1.15,
    transform: "translate(-31.07 35.34) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 119.02,
    y: 134.62,
    width: 1.15,
    height: 1.15,
    transform: "translate(-30.96 35.62) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 120.13,
    y: 134.32,
    width: 1.15,
    height: 1.15,
    transform: "translate(-30.84 35.9) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m121.34,134.13l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m118.08,136.19l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m119.42,136.77c.03.13-.04.26-.17.3l-.87.23-.3-1.11,1.11-.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m119.42,135.83l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m120.36,135.83l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m120.53,136.47c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 122.64,
    y: 134.83,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-30.89 36.57) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m124.96,134.34c-.13.03-.21.17-.17.3l.23.87,1.11-.3-.3-1.11-.87.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m126.71,133.87c.13-.03.26.04.3.17l.23.87-1.11.3-.3-1.11.87-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m120.89,137.81l-.23-.87c-.03-.13-.17-.21-.3-.17l-.64.17c-.13.03-.21.17-.17.3l.23.87,1.11-.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 121.83,
    y: 136.24,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-31.28 36.41) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m125.09,136.69c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 125.16,
    y: 135.35,
    width: 1.15,
    height: 1.15,
    transform: "translate(-30.94 37.24) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m127.48,135.79c.03.13-.04.26-.17.3l-.87.23-.3-1.11,1.11-.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m118.97,139.52l-.23-.87c-.03-.13-.17-.21-.3-.17l-.64.17c-.13.03-.21.17-.17.3l.23.87,1.11-.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 119.91,
    y: 137.94,
    width: 1.15,
    height: 1.15,
    transform: "translate(-31.79 35.97) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m124.22,136.92l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 124.34,
    y: 136.75,
    width: 1.15,
    height: 1.15,
    transform: "translate(-31.33 37.08) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m126.67,137.2c.03.13-.04.26-.17.3l-.87.23-.3-1.11,1.11-.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m126.67,136.26l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m118.09,140.69c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m120.31,140.09c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m123.7,139.44l-.23-.87c-.03-.13-.17-.21-.3-.17l-.64.17c-.13.03-.21.17-.17.3l.23.87,1.11-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m124.58,138.26l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m124.75,138.9c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m125.86,137.67l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m128.14,138.25l-.23-.87c-.03-.13-.17-.21-.3-.17l-.64.17c-.13.03-.21.17-.17.3l.23.87,1.11-.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 122.72,
    y: 139.56,
    width: 1.15,
    height: 1.15,
    transform: "translate(-32.11 36.75) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m127.26,139.42c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m110.69,144.12l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 110.82,
    y: 143.95,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.65 33.82) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 111.93,
    y: 143.65,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.54 34.09) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 113.04,
    y: 143.35,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.42 34.37) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m114.32,144.33l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m117.35,142.33l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 117.48,
    y: 142.16,
    width: 1.15,
    height: 1.15,
    transform: "translate(-32.96 35.48) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 118.58,
    y: 141.86,
    width: 1.15,
    height: 1.15,
    transform: "translate(-32.85 35.76) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 119.69,
    y: 141.57,
    width: 1.15,
    height: 1.15,
    transform: "translate(-32.73 36.03) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m120.97,142.55l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m123.12,141.72c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m126.22,139.95l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m127.09,139.71c.13-.03.26.04.3.17l.23.87-1.11.3-.3-1.11.87-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m128.5,140.53c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m127.86,140.7c-.13.03-.26-.04-.3-.17l.06.24.24-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m129.84,140.17l-.23-.87c-.03-.13-.17-.21-.3-.17l-.64.17c-.13.03-.21.17-.17.3l.23.87,1.11-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m132.06,139.57l-.23-.87c-.03-.13-.17-.21-.3-.17l-.64.17c-.13.03-.21.17-.17.3l.23.87,1.11-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m132.29,139.51c-.13.03-.26-.04-.3-.17l.06.24.24-.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 133,
    y: 138,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-31.35 39.36) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 135.22,
    y: 137.4,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-31.12 39.92) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m112.16,145.16l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m112.16,146.1c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 112.23,
    y: 144.76,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.82 34.21) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m113.44,144.57l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m116.83,144.85l-.23-.87c-.03-.13-.17-.21-.3-.17l-.64.17c-.13.03-.21.17-.17.3l.23.87,1.11-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m117.07,144.78c-.13.03-.26-.04-.3-.17l.06.24.24-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m118.82,143.38l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m118.99,144.01c.03.13.17.21.3.17l.87-.23-.3-1.11-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 119.99,
    y: 142.68,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.01 36.15) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m121.21,142.48l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m126.58,141.29l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m126.58,142.23c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 126.64,
    y: 140.89,
    width: 1.15,
    height: 1.15,
    transform: "translate(-32.32 37.81) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.75,
    y: 140.59,
    width: 1.15,
    height: 1.15,
    transform: "translate(-32.21 38.09) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 128.86,
    y: 140.29,
    width: 1.15,
    height: 1.15,
    transform: "translate(-32.09 38.37) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.37,141.21c-.13.03-.26-.04-.3-.17l.06.24.24-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m131.18,140.74c.03.13.17.21.3.17l.87-.23-.3-1.11-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m132.93,139.34c.13-.03.26.04.3.17l.23.87-1.11.3-.3-1.11.87-.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 136.62,
    y: 138.21,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-31.29 40.31) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m111.52,146.27c-.13.03-.21.17-.17.3l.23.87,1.11-.3-.3-1.11-.87.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 112.53,
    y: 145.87,
    width: 1.15,
    height: 1.15,
    transform: "translate(-34.09 34.32) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m115.96,146.02c.03.13.17.21.3.17l.87-.23-.3-1.11-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m117.13,145.95l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m120.22,144.19l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m120.22,145.12c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 120.29,
    y: 143.78,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.29 36.26) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m122.44,144.53c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m121.8,144.7c-.13.03-.26-.04-.3-.17l.06.24.24-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m122.61,143.29c-.13.03-.21.17-.17.3l.23.87,1.11-.3-.3-1.11-.87.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m123.78,144.17l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m125.94,142.4c-.13.03-.21.17-.17.3l.23.87,1.11-.3-.3-1.11-.87.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m128.16,142.74c.03.13-.04.26-.17.3l-.87.23-.3-1.11,1.11-.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m128.16,141.81l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m129.09,141.81l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m129.09,142.74c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 129.16,
    y: 141.4,
    width: 1.15,
    height: 1.15,
    transform: "translate(-32.37 38.48) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.44,142.38l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m132.42,140.91l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m132.59,141.55c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 134.7,
    y: 139.92,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-31.79 39.87) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 111.72,
    y: 147.27,
    width: 1.15,
    height: 1.15,
    transform: "translate(-34.49 34.16) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m114.04,147.72c.03.13-.04.26-.17.3l-.87.23-.3-1.11,1.11-.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m119.35,145.36l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 119.48,
    y: 145.19,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.68 36.1) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 120.59,
    y: 144.89,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.57 36.38) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 121.69,
    y: 144.6,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.45 36.66) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 122.8,
    y: 144.3,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.34 36.93) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m124.02,144.11l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m126.24,144.45c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m127.35,143.21l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m129.33,142.68l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.67,143.26c.03.13-.04.26-.17.3l-.87.23-.3-1.11,1.11-.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.67,142.32l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m111.95,149.72c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 112.01,
    y: 148.38,
    width: 1.15,
    height: 1.15,
    transform: "translate(-34.76 34.28) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m113.23,148.19l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 114.23,
    y: 147.79,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-34.53 34.83) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m117.43,147.06l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m117.73,148.17l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m119.71,146.7l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m119.88,147.34c.03.13.17.21.3.17l.87-.23-.3-1.11-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m122.1,146.75c.03.13-.04.26-.17.3l-.87.23-.3-1.11,1.11-.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m122.1,145.81l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m123.04,145.81l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m123.21,146.45c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 125.32,
    y: 144.81,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-33.38 37.6) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.54,
    y: 144.22,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-33.15 38.16) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.8,144.66c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.97,143.43c-.13.03-.21.17-.17.3l.23.87,1.11-.3-.3-1.11-.87.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 131.97,
    y: 143.03,
    width: 1.15,
    height: 1.15,
    transform: "translate(-32.69 39.27) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 133.08,
    y: 142.73,
    width: 1.15,
    height: 1.15,
    transform: "translate(-32.58 39.54) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m134.36,143.71l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m137.39,141.71l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m137.68,142.81l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m111.31,149.89c-.13.03-.21.17-.17.3l.23.87,1.11-.3-.3-1.11-.87.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m113.52,150.24c.03.13-.04.26-.17.3l-.87.23-.3-1.11,1.11-.3.23.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 115.64,
    y: 148.6,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-34.7 35.22) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m122.22,148.15c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m123.57,147.79l-.23-.87c-.03-.13-.17-.21-.3-.17l-.64.17c-.13.03-.21.17-.17.3l.23.87,1.11-.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 124.51,
    y: 146.22,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-33.78 37.44) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m128,146.6l-.23-.87c-.03-.13-.17-.21-.3-.17l-.64.17c-.13.03-.21.17-.17.3l.23.87,1.11-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m129.92,144.9l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 130.05,
    y: 144.73,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.2 38.83) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 131.16,
    y: 144.43,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.09 39.1) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 132.27,
    y: 144.13,
    width: 1.15,
    height: 1.15,
    transform: "translate(-32.97 39.38) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 133.38,
    y: 143.84,
    width: 1.15,
    height: 1.15,
    transform: "translate(-32.86 39.66) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m134.59,143.64l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 111.5,
    y: 150.9,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.43 34.23) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m112.71,150.71l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m113.82,150.41c-.13.03-.21.17-.17.3l.23.87,1.11-.3-.3-1.11-.87.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m114.99,151.28l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m118.02,149.28l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m118.32,150.39l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m122.46,148.09l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m123.8,148.67c.03.13-.04.26-.17.3l-.87.23-.3-1.11,1.11-.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m127.13,147.77c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.28,146.24l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 130.35,
    y: 145.84,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.48 38.94) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m132.67,146.28c.03.13-.04.26-.17.3l-.87.23-.3-1.11,1.11-.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m132.67,145.35l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m133.61,145.35l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m133.78,145.99c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m136.87,144.22l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 137,
    y: 144.05,
    width: 1.15,
    height: 1.15,
    transform: "translate(-32.79 40.61) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m138.85,143.69c.13-.03.26.04.3.17l.23.87-1.11.3-.3-1.11.87-.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 111.8,
    y: 152.01,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.71 34.34) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 114.01,
    y: 151.41,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.48 34.9) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m115.23,151.22l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m115.53,152.33c-.13.03-.26-.04-.3-.17l.06.24.24-.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 119.56,
    y: 149.92,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-34.91 36.29) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m125.21,148.54c-.13.03-.21.17-.17.3l.23.87,1.11-.3-.3-1.11-.87.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m126.38,149.41l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.58,148.29c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 130.65,
    y: 146.95,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.76 39.06) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m131.86,146.75l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m132.16,147.86c-.13.03-.26-.04-.3-.17l.06.24.24-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m137.23,145.57l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m137.4,146.2c.03.13.17.21.3.17l.87-.23-.3-1.11-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 138.41,
    y: 144.86,
    width: 1.15,
    height: 1.15,
    transform: "translate(-32.95 41) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m112.2,154.16c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m114.42,153.56c.03.13.17.21.3.17l.87-.23-.3-1.11-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 115.42,
    y: 152.22,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.64 35.29) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 116.53,
    y: 151.92,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.53 35.57) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 117.64,
    y: 151.63,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.41 35.85) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m118.92,152.61l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m121.07,150.84c-.13.03-.21.17-.17.3l.23.87,1.11-.3-.3-1.11-.87.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m122.24,151.71l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m125.51,150.59c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m126.62,149.35l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m129.71,148.52l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 129.84,
    y: 148.35,
    width: 1.15,
    height: 1.15,
    transform: "translate(-34.15 38.9) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 130.94,
    y: 148.06,
    width: 1.15,
    height: 1.15,
    transform: "translate(-34.03 39.17) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 132.05,
    y: 147.76,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.92 39.45) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 133.16,
    y: 147.46,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.8 39.73) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 134.27,
    y: 147.16,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.69 40) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m135.55,148.14l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m138.64,146.38l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 138.71,
    y: 145.97,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.23 41.11) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 121.26,
    y: 151.84,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.34 36.79) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m122.48,151.65l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 123.48,
    y: 151.25,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-35.11 37.35) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.07,149.87l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 130.13,
    y: 149.46,
    width: 1.15,
    height: 1.15,
    transform: "translate(-34.42 39.01) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m131.35,149.27l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m134.5,148.68l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 134.57,
    y: 148.27,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.96 40.12) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m135.78,148.08l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m138.94,148.42c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 139,
    y: 147.08,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.5 41.23) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m121.67,153.99c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m124.82,153.4c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m124.99,152.16c-.13.03-.21.17-.17.3l.23.87,1.11-.3-.3-1.11-.87.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m126.16,153.04l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 128.21,
    y: 151.17,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-34.93 38.57) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 130.43,
    y: 150.57,
    width: 1.15,
    height: 1.15,
    transform: "translate(-34.7 39.13) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 132.65,
    y: 149.98,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-34.47 39.68) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 134.87,
    y: 149.38,
    width: 1.15,
    height: 1.15,
    transform: "translate(-34.24 40.23) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m136.38,150.3c-.13.03-.26-.04-.3-.17l.06.24.24-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m138.06,148.66l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 138.19,
    y: 148.49,
    width: 1.15,
    height: 1.15,
    transform: "translate(-33.9 41.07) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m140.52,148.93c.03.13-.04.26-.17.3l-.87.23-.3-1.11,1.11-.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m124.18,153.57c-.13.03-.21.17-.17.3l.23.87,1.11-.3-.3-1.11-.87.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 125.18,
    y: 153.17,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.55 37.85) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m126.4,152.98l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m126.7,154.08c-.13.03-.26-.04-.3-.17l.06.24.24-.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 130.73,
    y: 151.68,
    width: 1.15,
    height: 1.15,
    transform: "translate(-34.98 39.24) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m132.24,152.6c-.13.03-.26-.04-.3-.17l.06.24.24-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m135.1,151.83c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 135.16,
    y: 150.49,
    width: 1.15,
    height: 1.15,
    transform: "translate(-34.52 40.35) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m137.02,150.13c.13-.03.26.04.3.17l.23.87-1.11.3-.3-1.11.87-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m123.43,156.15l-.23-.87c-.03-.13-.17-.21-.3-.17l-.64.17c-.13.03-.21.17-.17.3l.23.87,1.11-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m124.31,155.91c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m123.67,156.09c-.13.03-.26-.04-.3-.17l.06.24.24-.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 124.37,
    y: 154.57,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.95 37.69) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 125.48,
    y: 154.28,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.83 37.97) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m127.33,153.91c.13-.03.26.04.3.17l.23.87-1.11.3-.3-1.11.87-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.09,154.36l-.23-.87c-.03-.13-.17-.21-.3-.17l-.64.17c-.13.03-.21.17-.17.3l.23.87,1.11-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.96,154.13c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.32,154.3c-.13.03-.26-.04-.3-.17l.06.24.24-.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 131.03,
    y: 152.79,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.26 39.36) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 132.13,
    y: 152.49,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.14 39.63) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 133.24,
    y: 152.19,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.03 39.91) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 134.35,
    y: 151.9,
    width: 1.15,
    height: 1.15,
    transform: "translate(-34.91 40.19) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 135.46,
    y: 151.6,
    width: 1.15,
    height: 1.15,
    transform: "translate(-34.8 40.46) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m137.78,152.04c.03.13-.04.26-.17.3l-.87.23-.3-1.11,1.11-.3.23.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 122.45,
    y: 156.28,
    width: 1.15,
    height: 1.15,
    transform: "translate(-36.45 37.25) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 123.56,
    y: 155.98,
    width: 1.15,
    height: 1.15,
    transform: "translate(-36.34 37.53) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 124.67,
    y: 155.68,
    width: 1.15,
    height: 1.15,
    transform: "translate(-36.22 37.81) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m125.89,155.49l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m126.82,155.49l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 126.89,
    y: 155.09,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.99 38.36) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m129.04,155.83c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m128.4,156c-.13.03-.26-.04-.3-.17l.06.24.24-.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 129.11,
    y: 154.49,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.76 38.92) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 130.21,
    y: 154.2,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.65 39.19) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m132.54,154.64c.03.13-.04.26-.17.3l-.87.23-.3-1.11,1.11-.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m132.54,153.71l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m133.48,153.71l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m133.65,154.34c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m134.76,153.11l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m135.69,153.11l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 135.91,
    y: 152.69,
    width: 1.15,
    height: 2.3,
    transform: "translate(-35.21 40.64) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m136.97,152.51l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m140.06,151.69l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m140.94,151.45c.13-.03.26.04.3.17l.23.87-1.11.3-.3-1.11.87-.23Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 122.75,
    y: 157.39,
    width: 1.15,
    height: 1.15,
    transform: "translate(-36.73 37.37) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m123.97,157.19l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m124.9,157.2l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m125.07,157.83c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 127.19,
    y: 156.2,
    width: 1.15,
    height: 1.15,
    transform: "translate(-36.27 38.48) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 128.29,
    y: 155.9,
    width: 1.15,
    height: 1.15,
    transform: "translate(-36.16 38.75) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 129.4,
    y: 155.6,
    width: 1.15,
    height: 1.15,
    transform: "translate(-36.04 39.03) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m130.62,155.41l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m136.29,156.27c.13-.03.21-.17.17-.3l.06.24-.24.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 136.35,
    y: 154.92,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.63 40.81) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m137.87,155.84c-.13.03-.26-.04-.3-.17l.06.24.24-.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 138.27,
    y: 153.22,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-35.12 41.25) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m140.43,153.03l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m140.6,153.67c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 123.05,
    y: 158.5,
    width: 1.15,
    height: 1.15,
    transform: "translate(-37.01 37.48) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m127.59,158.35c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m128.7,157.11l-.24.06.06.24c-.03-.13.04-.26.17-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m129.64,157.11l-.06-.24-.24.06c.13-.03.26.04.3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m129.81,157.75c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m133.2,157.09l-.87.23c-.13.03-.21.17-.17.3l.17.64c.03.13.17.21.3.17l.87-.23-.3-1.11Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 133.33,
    y: 156.93,
    width: 1.15,
    height: 1.15,
    transform: "translate(-36.25 40.09) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 134.43,
    y: 156.63,
    width: 1.15,
    height: 1.15,
    transform: "translate(-36.14 40.37) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 135.54,
    y: 156.33,
    width: 1.15,
    height: 1.15,
    transform: "translate(-36.02 40.65) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 136.65,
    y: 156.03,
    width: 1.15,
    height: 1.15,
    transform: "translate(-35.91 40.92) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m137.93,157.01l.87-.23c.13-.03.21-.17.17-.3l-.17-.64c-.03-.13-.17-.21-.3-.17l-.87.23.3,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m123.45,160.65c.03.13.17.21.3.17l.64-.17c.13-.03.21-.17.17-.3l-.23-.87-1.11.3.23.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 128.89,
    y: 158.12,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-36.71 38.98) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 132.73,
    y: 154.71,
    width: 1.15,
    height: 1.15,
    rx: 0.24,
    ry: 0.24,
    transform: "translate(-35.7 39.86) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m114.19,135l1.42,5.27c.02.08-.02.15-.1.17l-5.27,1.42c-.08.02-.15-.02-.17-.1l-1.42-5.27c-.02-.08.02-.15.1-.17l5.27-1.42c.08-.02.15.02.17.1Zm-6.76.48c-.13.03-.2.14-.17.27l1.96,7.32c.03.13.17.21.3.17l7.29-1.96c.13-.03.21-.17.17-.3l-1.96-7.29c-.03-.13-.17-.21-.3-.17l-7.3,1.96Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 109.54,
    y: 135.8,
    width: 5.17,
    height: 5.17,
    rx: 0.37,
    ry: 0.37,
    transform: "translate(-32.04 33.8) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m134.15,129.64l1.42,5.27c.02.08-.02.15-.1.17l-5.27,1.42c-.08.02-.15-.02-.17-.1l-1.42-5.27c-.02-.08.02-.15.1-.17l5.27-1.42c.08-.02.15.02.17.1Zm-6.75.48c-.13.03-.21.17-.17.3l1.96,7.29c.03.13.17.21.3.17l7.29-1.96c.13-.03.21-.17.17-.3l-1.96-7.29c-.03-.13-.21-.19-.35-.16l-7.25,1.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 129.5,
    y: 130.44,
    width: 5.17,
    height: 5.17,
    rx: 0.37,
    ry: 0.37,
    transform: "translate(-29.97 38.79) rotate(-15.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m119.55,154.96l1.42,5.27c.02.08-.02.15-.1.17l-5.27,1.42c-.08.02-.15-.02-.17-.1l-1.42-5.27c-.02-.08.02-.15.1-.17l5.27-1.42c.08-.02.15.02.17.1Zm-6.75.48c-.13.03-.21.17-.17.3l1.93,7.21c.03.13.26.27.39.24l7.22-1.94c.13-.03.21-.17.17-.3l-1.96-7.29c-.03-.13-.17-.21-.3-.17l-7.29,1.96Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 114.9,
    y: 155.76,
    width: 5.17,
    height: 5.17,
    rx: 0.37,
    ry: 0.37,
    transform: "translate(-37.03 35.87) rotate(-15.02)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m281.37,66l-.22-.07,6.83-22.69c2.27-7.52-2.06-15.46-9.66-17.73L194.88.61c-7.6-2.27-15.6,1.99-17.87,9.52l-6.83,22.69-.22-.07c-.99-.3-2.04.26-2.33,1.24l-4.73,15.7c-.3.98.27,2.02,1.26,2.31l.22.07-1.13,3.74-.22-.07c-.99-.3-2.04.26-2.33,1.24l-4.73,15.7c-.3.98.27,2.02,1.26,2.31l.22.07-41.39,137.47c-2.27,7.52,2.06,15.46,9.66,17.73l83.44,24.9c7.6,2.27,15.6-1.99,17.87-9.52l45.42-150.84.22.07c.99.3,2.04-.26,2.33-1.24l7.63-25.32c.3-.98-.27-2.02-1.26-2.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 150.38,
    y: 13.2,
    width: 105.06,
    height: 229.37,
    rx: 6.21,
    ry: 6.21,
    transform: "translate(45.49 -53.07) rotate(16.76)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m197.92,20.96l-6.59-1.97c-.15-.04-.23-.2-.19-.35s.2-.23.35-.19l6.59,1.97c.15.04.23.2.19.35s-.2.23-.35.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m197.19,23.37l-6.59-1.97c-.15-.04-.23-.2-.19-.35s.2-.23.35-.19l6.59,1.97c.15.04.23.2.19.35s-.2.23-.35.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m196.47,25.78l-6.59-1.97c-.15-.04-.23-.2-.19-.35s.2-.23.35-.19l6.59,1.97c.15.04.23.2.19.35s-.2.23-.35.19Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m168.19,217.29c-.91-.27-1.87.24-2.14,1.14s.25,1.86,1.16,2.13c.91.27,1.87-.24,2.14-1.14.27-.9-.25-1.85-1.16-2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m173.81,222.56c-.91-.27-1.43-1.23-1.16-2.13s1.23-1.41,2.14-1.14c.91.27,1.43,1.23,1.16,2.13-.27.9-1.23,1.41-2.14,1.14Zm.82-2.73c-.61-.18-1.26.16-1.44.77s.17,1.25.78,1.43,1.26-.16,1.44-.77-.17-1.25-.78-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m180.42,224.56c-.91-.27-1.43-1.23-1.16-2.13s1.23-1.41,2.14-1.14,1.43,1.23,1.16,2.13c-.27.9-1.23,1.41-2.14,1.14Zm.82-2.73c-.61-.18-1.26.16-1.44.77s.17,1.25.78,1.43c.61.18,1.26-.16,1.44-.77.18-.61-.17-1.25-.78-1.43Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 191.16,
    cy: 165.97,
    rx: 16.69,
    ry: 16.86,
    transform: "translate(-4.17 327.02) rotate(-80.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m182.25,163.74l2.26,8.71c.13.51.67.7,1.1.38l15.48-11.74c.77-.57.25-1.82-.6-1.44l-13.28,8.34c-.28.13-.59.06-.79-.17l-2.88-4.96c-.52-.62-1.5.06-1.28.89Z"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "cls-19",
    transform: "translate(159.05 197.05) rotate(16.62) skewX(-.14)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 0,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 6.43,
    y: 0
  }, "alidado")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m214.03,56.67c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m216.95,57.54l.56-1.87c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m226.05,60.25c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m228.96,61.12l.56-1.87c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m234.33,60.68c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m214.55,56.82l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "213.83 59.2 216.23 59.91 216.95 57.54 214.55 56.82 213.83 59.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m218.12,60.48c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m216.74,60.07c-.28-.08-.44-.38-.36-.66l-.15.51.51.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m219.86,58.4c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72.72-2.38-1.89-.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "221.04 61.35 223.44 62.06 224.16 59.69 221.75 58.97 221.04 61.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "223.44 62.06 225.84 62.78 226.56 60.4 224.16 59.69 223.44 62.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m228.4,62.99c-.08.28-.38.44-.66.35l-1.89-.56.72-2.38,2.4.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m213.68,59.7l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m212.6,61.42c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "213.11 61.57 215.52 62.29 216.23 59.91 213.83 59.2 213.11 61.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "215.52 62.29 217.92 63.01 218.63 60.63 216.23 59.91 215.52 62.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "217.92 63.01 220.32 63.72 221.04 61.35 218.63 60.63 217.92 63.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m221.55,61.5l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m213.11,61.57l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m214.95,64.16c-.08.28-.38.44-.66.35l-1.89-.56.72-2.38,2.4.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m216.03,62.44l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m217.77,63.51l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m217.35,64.88c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m224.97,65.66c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m228.04,66.03c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72.72-2.38-1.89-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m231.82,67.16c.28.08.44.38.36.66l-.56,1.87-2.4-.72.72-2.38,1.89.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m216.49,67.76l.56-1.87c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m221.86,67.32c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m225.59,70.48c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "226.1 70.63 228.5 71.35 229.22 68.97 226.81 68.25 226.1 70.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m231.05,71.56c-.08.28-.38.44-.66.35l-1.89-.56.72-2.38,2.4.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m210.97,68.71l.56-1.87c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "213.37 69.42 215.77 70.14 216.49 67.76 214.08 67.05 213.37 69.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m223.69,69.91l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "222.98 72.29 225.38 73.01 226.1 70.63 223.69 69.91 222.98 72.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m227.94,73.22c-.08.28-.38.44-.66.35l-1.89-.56.72-2.38,2.4.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m229.01,71.5l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m208,69.86c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m212.8,71.3c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m219.86,73.95l.56-1.87c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m222.83,72.8l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m222.41,74.16c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m225.89,73.16l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m229.47,76.82l.56-1.87c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "216.74 75.61 219.14 76.33 219.86 73.95 217.46 73.24 216.74 75.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m226.5,77.98c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m190.31,67.73l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "189.6 70.1 192 70.82 192.71 68.44 190.31 67.73 189.6 70.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "192 70.82 194.4 71.54 195.12 69.16 192.71 68.44 192 70.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "194.4 71.54 196.8 72.25 197.52 69.88 195.12 69.16 194.4 71.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m196.8,72.25l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m204.73,72.03l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "204.01 74.41 206.41 75.12 207.13 72.75 204.73 72.03 204.01 74.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "206.41 75.12 208.82 75.84 209.53 73.46 207.13 72.75 206.41 75.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "208.82 75.84 211.22 76.56 211.94 74.18 209.53 73.46 208.82 75.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m211.22,76.56l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m216.18,77.49c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m223.95,77.76l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m225.84,78.33c.28.08.44.38.36.66l-.56,1.87-2.4-.72.72-2.38,1.89.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m227.53,81.42c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m226.15,81.01c-.28-.08-.44-.38-.36-.66l-.15.51.51.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m230.44,82.29l.56-1.87c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m235.25,83.73l.56-1.87c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m235.76,83.88c-.28-.08-.44-.38-.36-.66l-.15.51.51.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m240.62,83.29c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m245.42,84.72c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m191.85,71.33l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m190.77,73.05c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "191.28 73.2 193.69 73.92 194.4 71.54 192 70.82 191.28 73.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m194.91,71.69l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m200.89,76.07l.56-1.87c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m201.4,76.22c-.28-.08-.44-.38-.36-.66l-.15.51.51.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m206.26,75.63l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m205.85,77c-.08.28.08.57.36.66l1.89.56.72-2.38-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "208.1 78.22 210.5 78.93 211.22 76.56 208.82 75.84 208.1 78.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m211.73,76.71l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m223.08,80.65l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m222.01,82.37c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "222.52 82.52 224.92 83.24 225.64 80.86 223.23 80.14 222.52 82.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "224.92 83.24 227.32 83.95 228.04 81.58 225.64 80.86 224.92 83.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "227.32 83.95 229.73 84.67 230.44 82.29 228.04 81.58 227.32 83.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m230.24,84.82c-.28-.08-.44-.38-.36-.66l-.15.51.51.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m232.28,84.88c-.08.28.08.57.36.66l1.89.56.72-2.38-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m237.14,84.29c.28.08.44.38.36.66l-.56,1.87-2.4-.72.72-2.38,1.89.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m247.11,87.82c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m189.39,72.63c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72.72-2.38-1.89-.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "190.57 75.58 192.97 76.29 193.69 73.92 191.28 73.2 190.57 75.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m197.93,77.22c-.08.28.08.57.36.66l1.89.56.72-2.38-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m200.18,78.44l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m207.95,78.72l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m206.88,80.44c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "207.39 80.59 209.79 81.31 210.5 78.93 208.1 78.22 207.39 80.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m211.68,81.88c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m210.3,81.46c-.28-.08-.44-.38-.36-.66l-.15.51.51.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m213.42,79.8c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72.72-2.38-1.89-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m214.59,82.75l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m220.63,81.95c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72.72-2.38-1.89-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m224.36,85.11c-.08.28-.38.44-.66.35l-1.89-.56.72-2.38,2.4.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m225.43,83.39l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m227.17,84.46l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m226.1,86.18c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "226.61 86.33 229.01 87.05 229.73 84.67 227.32 83.95 226.61 86.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m229.01,87.05l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m234.38,86.61l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m233.97,87.98c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m241.59,88.76c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "187.45 77.24 189.85 77.95 190.57 75.58 188.16 74.86 187.45 77.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m192.41,78.17c-.08.28-.38.44-.66.35l-1.89-.56.72-2.38,2.4.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m204.98,79.88l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "204.27 82.26 206.67 82.97 207.39 80.59 204.98 79.88 204.27 82.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "206.67 82.97 209.07 83.69 209.79 81.31 207.39 80.59 206.67 82.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "209.07 83.69 211.48 84.41 212.19 82.03 209.79 81.31 209.07 83.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "211.48 84.41 213.88 85.12 214.59 82.75 212.19 82.03 211.48 84.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m215.1,82.9l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m218.84,86.05c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m222.31,85.05l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m226.61,86.33l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m228.45,88.92c-.08.28-.38.44-.66.35l-1.89-.56.72-2.38,2.4.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m229.52,87.2l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m186.22,79.46c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "186.73 79.61 189.14 80.33 189.85 77.95 187.45 77.24 186.73 79.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m190.36,78.11l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m194.5,79.89c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m199.46,80.82l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m198.75,83.2l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m204.11,82.76l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m203.7,84.13c-.08.28.08.57.36.66l1.89.56.72-2.38-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m208.51,85.56c-.08.28-.38.44-.66.35l-1.89-.56.72-2.38,2.4.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m209.58,83.84l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m211.32,84.91l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m210.91,86.28c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m218.53,87.06c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m223.34,88.5c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m227.07,91.65c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m228.8,89.58c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72.72-2.38-1.89-.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "229.98 92.52 232.38 93.24 233.1 90.86 230.7 90.14 229.98 92.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "232.38 93.24 234.79 93.95 235.5 91.58 233.1 90.86 232.38 93.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m234.79,93.95l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m242.71,93.73l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m241.99,96.11l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m184.84,79.05c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72.72-2.38-1.89-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m188.57,82.2c-.08.28-.38.44-.66.35l-1.89-.56.72-2.38,2.4.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m196.19,82.99c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m207.13,88.29c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m210.04,89.16l.56-1.87c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m215.41,88.72c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m219.65,92.03l.56-1.87c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m225.18,91.09l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "224.46 93.46 226.86 94.18 227.58 91.8 225.18 91.09 224.46 93.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "226.86 94.18 229.26 94.9 229.98 92.52 227.58 91.8 226.86 94.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "229.26 94.9 231.67 95.61 232.38 93.24 229.98 92.52 229.26 94.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "231.67 95.61 234.07 96.33 234.79 93.95 232.38 93.24 231.67 95.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m235.3,94.11l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "182.9 83.65 185.3 84.37 186.02 81.99 183.61 81.28 182.9 83.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m186.53,82.14l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m188.93,82.86c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72.72-2.38-1.89-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m190.11,85.8l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m198.03,85.58l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m197.31,87.95l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m207.64,88.45l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m209.48,91.03c-.08.28-.38.44-.66.35l-1.89-.56.72-2.38,2.4.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m216.69,93.19c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m224.31,93.97l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "223.74 95.84 226.15 96.56 226.86 94.18 224.46 93.46 223.74 95.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m228.7,96.77c-.08.28-.38.44-.66.35l-1.89-.56.72-2.38,2.4.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m229.78,95.05l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m231.52,96.12l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m231.1,97.49c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m238.88,97.77l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "238.16 100.14 240.56 100.86 241.28 98.48 238.88 97.77 238.16 100.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m243.17,99.05c.28.08.44.38.36.66l-.56,1.87-2.4-.72.72-2.38,1.89.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "182.18 86.03 184.58 86.75 185.3 84.37 182.9 83.65 182.18 86.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "186.99 87.46 189.39 88.18 190.11 85.8 187.7 85.09 186.99 87.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m190.62,85.96l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m189.9,88.33c-.28-.08-.44-.38-.36-.66l-.15.51.51.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m201.97,89.89c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m212.24,92.41c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72.72-2.38-1.89-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m213.42,95.35l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m222.52,98.07c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "223.03 98.22 225.43 98.94 226.15 96.56 223.74 95.84 223.03 98.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m226.66,96.71l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m225.94,99.09c-.28-.08-.44-.38-.36-.66l-.15.51.51.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m238.01,100.65l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m237.6,102.02c-.08.28.08.57.36.66l1.89.56.72-2.38-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "239.85 103.24 242.25 103.96 242.96 101.58 240.56 100.86 239.85 103.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m181.62,87.9c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m186.42,89.34c-.08.28.08.57.36.66l1.89.56.72-2.38-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "188.67 90.56 191.08 91.28 191.79 88.9 189.39 88.18 188.67 90.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "191.08 91.28 193.48 91.99 194.2 89.62 191.79 88.9 191.08 91.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "193.48 91.99 195.88 92.71 196.6 90.33 194.2 89.62 193.48 91.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m195.88,92.71l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m201.91,91.92c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72.72-2.38-1.89-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m203.09,94.86l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m210.45,96.51c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m213.93,95.5l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m220.62,97.5l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "219.91 99.88 222.31 100.6 223.03 98.22 220.62 97.5 219.91 99.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "222.31 100.6 224.71 101.31 225.43 98.94 223.03 98.22 222.31 100.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "224.71 101.31 227.12 102.03 227.83 99.65 225.43 98.94 224.71 101.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "227.12 102.03 229.52 102.75 230.24 100.37 227.83 99.65 227.12 102.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "229.52 102.75 231.92 103.47 232.64 101.09 230.24 100.37 229.52 102.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m231.92,103.47l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m239.69,103.74l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "239.13 105.62 241.53 106.33 242.25 103.96 239.85 103.24 239.13 105.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "199.97 96.52 202.37 97.24 203.09 94.86 200.69 94.14 199.97 96.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m203.6,95.01l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m207.74,96.8c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m219.76,100.39l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "219.19 102.26 221.6 102.97 222.31 100.6 219.91 99.88 219.19 102.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m222.82,100.75l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m229.37,103.25l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "228.8 105.13 231.21 105.84 231.92 103.47 229.52 102.75 228.8 105.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m232.43,103.62l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m237.9,107.84c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "238.41 107.99 240.82 108.71 241.53 106.33 239.13 105.62 238.41 107.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m199.41,98.39c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m205.95,100.9c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m207.69,98.83c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72.72-2.38-1.89-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m208.87,101.77l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m216.64,102.05c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "218.48 104.64 220.88 105.35 221.6 102.97 219.19 102.26 218.48 104.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m226.25,104.91c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "228.09 107.5 230.49 108.22 231.21 105.84 228.8 105.13 228.09 107.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m231,108.37c-.28-.08-.44-.38-.36-.66l-.15.51.51.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m236.01,107.28l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "235.3 109.65 237.7 110.37 238.41 107.99 236.01 107.28 235.3 109.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m240.25,110.58c-.08.28-.38.44-.66.35l-1.89-.56.72-2.38,2.4.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m204.57,100.49c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72.72-2.38-1.89-.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "205.75 103.43 208.15 104.15 208.87 101.77 206.46 101.05 205.75 103.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m209.38,101.92l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m208.66,104.3c-.28-.08-.44-.38-.36-.66l-.15.51.51.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "217.76 107.01 220.16 107.73 220.88 105.35 218.48 104.64 217.76 107.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m220.67,107.88c-.28-.08-.44-.38-.36-.66l-.15.51.51.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m226.86,109.73c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "227.37 109.88 229.77 110.6 230.49 108.22 228.09 107.5 227.37 109.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m232.38,108.79c.28.08.44.38.36.66l-.56,1.87-2.4-.72.72-2.38,1.89.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m200.23,104.37l.56-1.87c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m202.12,104.94c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m200.74,104.52c-.28-.08-.44-.38-.36-.66l-.15.51.51.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "202.63 105.09 205.03 105.81 205.75 103.43 203.34 102.71 202.63 105.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "205.03 105.81 207.43 106.52 208.15 104.15 205.75 103.43 205.03 105.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m210.04,104.71c.28.08.44.38.36.66l-.56,1.87-2.4-.72.72-2.38,1.89.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m214.64,108.67l.56-1.87c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.08-.66.35l-.56,1.87,2.4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m216.53,109.24c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m215.15,108.83c-.28-.08-.44-.38-.36-.66l-.15.51.51.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "217.04 109.39 219.45 110.11 220.16 107.73 217.76 107.01 217.04 109.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "219.45 110.11 221.85 110.82 222.57 108.45 220.16 107.73 219.45 110.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "221.85 110.82 224.25 111.54 224.97 109.16 222.57 108.45 221.85 110.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "224.25 111.54 226.66 112.26 227.37 109.88 224.97 109.16 224.25 111.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "226.66 112.26 229.06 112.98 229.77 110.6 227.37 109.88 226.66 112.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m231.61,113.19c-.08.28-.38.44-.66.35l-1.89-.56.72-2.38,2.4.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "197.11 106.03 199.51 106.75 200.23 104.37 197.82 103.66 197.11 106.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "199.51 106.75 201.91 107.47 202.63 105.09 200.23 104.37 199.51 106.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "201.91 107.47 204.32 108.18 205.03 105.81 202.63 105.09 201.91 107.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m205.54,105.96l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m207.28,107.03l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "206.72 108.9 209.12 109.62 209.84 107.24 207.43 106.52 206.72 108.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m211.01,110.18c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m209.63,109.77c-.28-.08-.44-.38-.36-.66l-.15.51.51.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "211.52 110.33 213.93 111.05 214.64 108.67 212.24 107.96 211.52 110.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "213.93 111.05 216.33 111.77 217.04 109.39 214.64 108.67 213.93 111.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m218.88,111.98c-.08.28-.38.44-.66.35l-1.89-.56.72-2.38,2.4.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m219.96,110.26l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m221.7,111.33l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m221.29,112.7c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m224.76,111.69l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m226.5,112.76l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "225.22 117.01 227.63 117.73 229.06 112.98 226.66 112.26 225.22 117.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m229.57,113.13l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m236.27,115.13l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m238.16,115.69c.28.08.44.38.36.66l-.56,1.87-2.4-.72.72-2.38,1.89.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "196.39 108.41 198.79 109.13 199.51 106.75 197.11 106.03 196.39 108.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m200.02,106.9l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m201.76,107.97l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m201.35,109.34c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "206 111.28 208.4 112 209.12 109.62 206.72 108.9 206 111.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "208.4 112 210.81 112.71 211.52 110.33 209.12 109.62 208.4 112"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "210.81 112.71 213.21 113.43 213.93 111.05 211.52 110.33 210.81 112.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m214.44,111.2l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m224,119.24c.28.08.58-.08.66-.35l-.15.51-.51-.15Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "224.51 119.39 226.91 120.11 227.63 117.73 225.22 117.01 224.51 119.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m227.42,120.26c-.28-.08-.44-.38-.36-.66l-.15.51.51.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m233,117.29c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m235.4,118.01l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m234.99,119.38c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "195.68 110.79 198.08 111.51 198.79 109.13 196.39 108.41 195.68 110.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m205.44,113.15c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m208.92,112.15l-.51-.15-.15.51c.08-.28.38-.44.66-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m210.66,113.22l.15-.51-.51-.15c.28.08.44.38.36.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m210.24,114.58c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m217.3,117.24l-1.89-.56c-.28-.08-.58.08-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.89.56.72-2.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "216.58 119.62 218.99 120.34 219.7 117.96 217.3 117.24 216.58 119.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "218.99 120.34 221.39 121.05 222.1 118.67 219.7 117.96 218.99 120.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "221.39 121.05 223.79 121.77 224.51 119.39 222.1 118.67 221.39 121.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "223.79 121.77 226.19 122.49 226.91 120.11 224.51 119.39 223.79 121.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m226.19,122.49l1.89.56c.28.08.58-.08.66-.35l.41-1.37c.08-.28-.08-.57-.36-.66l-1.89-.56-.72,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m195.11,112.66c-.08.28.08.57.36.66l1.38.41c.28.08.58-.08.66-.35l.56-1.87-2.4-.72-.56,1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m209.94,115.6c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m220.98,113.71c.08-.28-.08-.57-.36-.66l-1.38-.41c-.28-.08-.58.07-.66.35l-.41,1.37c-.08.28.08.57.36.66l1.38.41c.28.08.58-.07.66-.35l.41-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m207.25,54.96l-3.41,11.31c-.05.16-.22.25-.38.2l-11.43-3.41c-.16-.05-.25-.22-.21-.38l3.41-11.31c.05-.16.22-.25.38-.2l11.43,3.41c.16.05.25.22.21.38Zm-13.13-6.83c-.28-.08-.53.02-.61.3l-4.73,15.69c-.08.28.08.57.36.66l15.8,4.71c.28.08.58-.07.66-.35l4.71-15.64c.08-.28-.08-.57-.36-.66l-15.83-4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m202.76,63.78l2.21-7.35c.1-.33-.09-.69-.43-.79l-7.42-2.22c-.34-.1-.7.09-.8.42l-2.21,7.35c-.1.33.09.69.43.79l7.42,2.22c.34.1.7-.09.8-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m250.5,67.86l-3.41,11.31c-.05.16-.22.25-.38.2l-11.43-3.41c-.16-.05-.25-.22-.21-.38l3.41-11.31c.05-.16.22-.25.38-.2l11.43,3.41c.16.05.25.22.21.38Zm-13.1-6.82c-.28-.08-.58.08-.66.35l-4.71,15.64c-.08.28.08.57.36.66l15.8,4.71c.28.08.58-.07.66-.35l4.71-15.64c.08-.28-.18-.6-.46-.68l-15.7-4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m246.01,76.69l2.21-7.35c.1-.33-.09-.69-.43-.79l-7.42-2.22c-.34-.1-.7.09-.8.42l-2.21,7.35c-.1.33.09.69.43.79l7.42,2.22c.34.1.7-.09.8-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m194.36,97.76l-3.41,11.31c-.05.16-.22.25-.38.2l-11.43-3.41c-.16-.05-.25-.22-.21-.38l3.41-11.31c.05-.16.22-.25.38-.2l11.43,3.41c.16.05.25.22.21.38Zm-13.1-6.82c-.28-.08-.58.08-.66.35l-4.65,15.45c-.08.28.18.8.46.89l15.64,4.67c.28.08.58-.07.66-.35l4.71-15.64c.08-.28-.08-.57-.36-.66l-15.8-4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m189.87,106.58l2.21-7.35c.1-.33-.09-.69-.43-.79l-7.42-2.22c-.34-.1-.7.09-.8.42l-2.21,7.35c-.1.33.09.69.43.79l7.42,2.22c.34.1.7-.09.8-.42Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "238.43 130.18 170.88 110.02 191.01 43.16 258.56 63.32 238.43 130.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m236.74,147c.06-.21.03-.4-.07-.43l-73.85-22.04c-.12-.04-.27.1-.33.31s-.01.4.11.44l73.85,22.04c.1.03.24-.11.3-.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m256.48,93.21c.21-.7.29-1.29.18-1.32l-79.23-23.64c-.13-.04-.41.49-.62,1.19-.21.7-.27,1.29-.14,1.33l79.23,23.64c.11.03.37-.51.58-1.2h0Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidacion);
export default __webpack_public_path__ + "static/media/Validacion.a2dc44a483eeada9bacf304693fb6940.svg";
export { ForwardRef as ReactComponent };